<template>
    <div class="menu-content">
        <div class="distance-box">
            <i class="el-icon-place"></i>
            <span v-if="info.deliveryDistance">Distance Covered: {{ deliveryDistance }}</span>
            <span v-else>PICK UP ONLY</span>
            <span style="flex:1;"></span>
            <!-- <span>£2 delivery fee</span> -->
        </div>
        <div class="menu-title">
            <h2>Menu</h2>
        </div>

        <!--  搜索结果展示 -->
        <div class="search-box" v-if="showSearchCover">
            <div class="cate-box">
                <div class="food-header food-item">
                    <div class="item-name">Item</div>
                    <!-- <div class="item-price"> Price</div> -->
                    <div class="item-order"> Order </div>
                </div>
                <section class="food-box" v-if="searchResult.length">
                    <div class="food-item" v-for="(food, foodIdx) in searchResult" :key="'search-' + (food.itemId || '') + '-' + foodIdx">
                        <div class="item-name">
                            <div class="food-img" v-if="food.photo">
                                <viewer :images="[food.photo]"> 
                                    <img v-if="food.photo" :src="food.photo" style="object-fit: contain;" alt="">
                                </viewer>
                            </div>
                            <div>
                                <span class="name">{{ food.itemName }}</span>
                                <template v-if="food.foodEmoji" >
                                    <el-tooltip class="item" effect="dark" :content="food.foodEmojiDesc" placement="bottom">
                                        <span class="name-desc" >{{ food.foodEmoji }}</span>
                                    </el-tooltip>
                                </template> <br />
                                <span class="desc">{{ food.itemDescription }}</span>
                                <div class="price"> 
                                    {{ currencySign }}{{ food.price?(food.price*1).toFixed(2):food.price }} 
                                </div>
                            </div>
                        </div>
                        <!-- <div class="item-price"> {{ currencySign }}{{ food.price?food.price.toFixed(2):food.price }} </div> -->
                        <div class="item-order" v-if="addCartLoading == food.itemId">
                            <i class="el-icon-loading"></i>
                        </div>
                        <div class="item-order" v-else>
                            <div class="add-btn" @click="addCart(food, true)" 
                                v-if="food.qty<=0 && !( (food.foodSkuPriceList&&food.foodSkuPriceList.length>1) || food.isAddon)">
                                <i class="el-icon-plus"></i>
                                <span>Add</span>
                            </div>
                            <div class="add-btn add-addon" @click="addCart(food, true)" 
                                v-if="(food.foodSkuPriceList&&food.foodSkuPriceList.length>1) || food.isAddon">
                                <span>Add</span>
                            </div>
                            <div class="add-btn update-btn" v-else-if="food.qty>0">
                                <i class="el-icon-minus" @click="addCart(food, false)"></i>
                                <span class="qty">{{ food.qty }}</span>
                                <i class="el-icon-plus" @click="addCart(food, true)"></i>
                            </div>
                        </div>
                    </div>
                </section>
                <section v-else-if="searchLoading" class="loading-box">
                    <i class="el-icon-loading" ></i>
                </section>
                <section v-else class="loading-box">
                    <img class="empty-img" src="@/assets/menu/empty_cart2.png" alt="empty">
                </section>
            </div>
        </div>
        <div v-show="!showSearchCover">
            <div v-for="item in categoryList" :key="item.catId" class="cate-box" :data-cateId="item.catId" :id="'catId-' + item.catId"  >
                <h2>{{ item.categoryName }}</h2>
                <div class="desc" v-if="item.categoryDescription">{{ item.categoryDescription }}</div>
                <div v-else style="height: 10px;" ></div>
                <div class="food-header food-item">
                    <div class="item-name">Item</div>
                    <!-- <div class="item-price"> Price</div> -->
                    <div class="item-order"> Order </div>
                </div>
                <section class="food-box" v-if="item.foodList.length">
                    <div class="food-item" v-for="(food, foodIdx) in item.foodList" :key="'cat-' + item.catId + '-' + (food.itemId || '') + '-' + foodIdx">
                        <div class="item-name">
                            <div class="food-img" v-if="food.photo">
                                <viewer :images="[food.photo]"> 
                                    <img v-if="food.photo" :src="food.photo" style="object-fit: contain;" alt="">
                                </viewer>
                            </div>
                            <div>
                                <span class="name">{{ food.itemName }}</span>
                                <template v-if="food.foodEmoji" >
                                    <el-tooltip class="item" effect="dark" :content="food.foodEmojiDesc" placement="bottom">
                                        <span class="name-desc" >{{ food.foodEmoji }}</span>
                                    </el-tooltip>
                                </template> <br />
                                <span class="desc">{{ food.itemDescription }}</span>
                                <div class="price"> 
                                    <span class="origin-price" v-if="food.originPrice" >{{ currencySign }}{{ food.originPrice?(food.originPrice*1).toFixed(2):food.originPrice }}</span>
                                    {{ currencySign }}{{ food.price?(food.price*1).toFixed(2):food.price }} 
                                </div>
                            </div>
                        </div>
                        <!-- <div class="item-price"> 
                            {{ currencySign }}{{ food.price?food.price.toFixed(2):food.price }} 
                        </div> -->
                        <div class="item-order" v-if="addCartLoading == food.itemId">
                            <i class="el-icon-loading"></i>
                        </div>
                        <div class="item-order" v-else>
                            <div class="add-btn" @click="addCart(food, true)" 
                                v-if="food.qty<=0 && !((food.foodSkuPriceList&&food.foodSkuPriceList.length>1) || food.isAddon)">
                                <i class="el-icon-plus"></i>
                                <span>Add</span>
                            </div>
                            <div class="add-btn" @click="addCart(food, true)" 
                                v-if="(food.foodSkuPriceList && food.foodSkuPriceList.length>1) || food.isAddon">
                                <span>Add</span>
                            </div>
                            <div class="add-btn update-btn" v-else-if="food.qty>0">
                                <i class="el-icon-minus" @click="addCart(food, false)"></i>
                                <span class="qty">{{ food.qty }}</span>
                                <i class="el-icon-plus" @click="addCart(food, true)"></i>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="menu-load-mask" >
                        <el-skeleton animated >
                            <template slot="template">
                                <el-skeleton-item variant="text"  animated style="width: 100%; height: 80px;" />
                                <i class="el-icon-loading" ></i>
                            </template>
                            
                        </el-skeleton>
                    </div> -->
                </section>
                <section v-else-if="!item.foodList.length && item.loadDone!=true" class="loading-box">
                    <i class="el-icon-loading" ></i>
                </section>
            </div>
        </div>

        <!-- 多价格规格弹窗展示 -->
        <el-dialog
            :visible.sync="showModal"
            :width="isMobile?'90%':'30%'"
            custom-class="food-detail-dialog"
            :before-close="handleClose">
            <div slot="title" class="modal-title">
                {{ nowChooseFood.itemName }}
            </div>
            <div class="modal-content" :class="['foodtag-mode-' + getFoodTagMode()]">
                <div
                    v-if="isSortedStepFlow && sortedFlowTotalSteps > 0"
                    class="addon-sort-progress-track"
                    role="progressbar"
                    :aria-valuenow="addonSortProgressPercent"
                    aria-valuemin="0"
                    aria-valuemax="100"
                >
                    <div class="addon-sort-progress-fill" :style="{ width: addonSortProgressPercent + '%' }"></div>
                </div>
                <div
                    v-if="showSortedSplitTabsArea && currentSortedAddonGroup && splitAddonUiBundleKey(currentSortedAddonGroup)"
                    class="addon-split-mode-tabs addon-split-mode-tabs--step-header"
                >
                    <button
                        type="button"
                        class="addon-split-mode-btn"
                        :class="{ 'is-active': getAddonSplitUiBranch(splitAddonUiBundleKey(currentSortedAddonGroup)) === 'whole' }"
                        @click="setAddonSplitBranch(splitAddonUiBundleKey(currentSortedAddonGroup), 'whole')"
                    >
                        Entire item
                    </button>
                    <button
                        type="button"
                        class="addon-split-mode-btn"
                        :class="{ 'is-active': getAddonSplitUiBranch(splitAddonUiBundleKey(currentSortedAddonGroup)) === 'portion' }"
                        @click="setAddonSplitBranch(splitAddonUiBundleKey(currentSortedAddonGroup), 'portion')"
                    >
                        Split portions
                    </button>
                </div>
                <template v-if="shouldShowMainModalSkuPicker">
                    <div class="price-title" >Specifications</div>
                    <ul>
                        <li v-for="(price,ind) in nowChooseFood.foodSkuPriceList" :key="ind" @click="nowChoosePrice(price, ind)"
                            :class="['price-item',{'price-item-active': String(nowPrice.sizeId) === String(price.sizeId)}]">
                            <span>{{ price.sizeName }}</span>
                            <div>
                                <span class="old-price" v-if="price.originPrice" >{{ currencySign + price.originPrice }}</span>
                                <span >{{ currencySign + price.foodPrice }}</span>
                            </div>
                        </li>
                    </ul>
                </template>
                <div class="dash-row" v-if="showAddonTitle && mainModalAddonBodyVisible"></div>
                <div class="price-title" v-if="showAddonTitle && mainModalAddonBodyVisible">Additional items</div>
                <div class="food-loading" v-if="loadingFood">
                    <i class="el-icon-loading" ></i>
                </div>
                <template v-else>
                    <!-- 有价格 的 addon -->
                    <ul v-if="previewAddonGroupsVisible && previewAddonGroupsVisible.length">
                        <li
                            v-for="(value, key) in previewAddonGroupsVisible"
                            :key="splitAddonGroupKey(value, value.__sourceIndex)"
                            v-show="!isSortedStepFlow || isGroupInCurrentLogicalStep(value)"
                        >
                            <div
                                v-if="!isSortedStepFlow && splitAddonUiBundleKey(value) && (value.__splitBranchType === 'whole' || (value.__splitBranchType === 'portion' && Number(value.__splitPreviewSlotIndex) === 0))"
                                class="addon-split-mode-tabs"
                            >
                                <button
                                    type="button"
                                    class="addon-split-mode-btn"
                                    :class="{ 'is-active': getAddonSplitUiBranch(splitAddonUiBundleKey(value)) === 'whole' }"
                                    @click="setAddonSplitBranch(splitAddonUiBundleKey(value), 'whole')"
                                >
                                    Entire item
                                </button>
                                <button
                                    type="button"
                                    class="addon-split-mode-btn"
                                    :class="{ 'is-active': getAddonSplitUiBranch(splitAddonUiBundleKey(value)) === 'portion' }"
                                    @click="setAddonSplitBranch(splitAddonUiBundleKey(value), 'portion')"
                                >
                                    Split portions
                                </button>
                            </div>
                            <div class="addon-title">
                                {{ getAddonGroupName(value) }}
                                ({{[0,1].includes(value.selectType)?'Single Choice':'Multiple Select'}}  {{value.required?'| '+ 'required':''}}) 
                                <span v-if="value.selectType==3" >Max choose {{value.customSize}}</span>
                                <span class="addon-meta-tag" v-if="Number(foodDetails.addonSort || 0) === 1">#{{ getAddonSortIndex(value, key) }}</span>
                                <span
                                  v-if="Number(foodDetails.addonSort || 0) === 1"
                                  :class="['addon-step-state', 'is-' + getStepStatusBySortedIndex(value)]"
                                >
                                  {{ getStepStatusBySortedIndex(value) === 'current' ? 'Current' : (getStepStatusBySortedIndex(value) === 'done' ? 'Done' : 'Locked') }}
                                </span>
                                <span class="addon-meta-tag" v-if="Number(value.freeLimit || 0) === 1">first {{ value.freeLimitCount || 0 }} free</span>
                                <span class="addon-meta-tag" v-if="Number(value.sizePrice || 0) === 1">size price</span>
                                <span class="addon-meta-tag" v-if="Number(value.allowQty || 0) === 1">qty selectable</span>
                            </div>
                            <div
                                v-if="isSortedStepFlow && isGroupInCurrentLogicalStep(value) && addonSplitStepScopeLabel(value)"
                                class="addon-split-step-scope"
                            >
                                {{ addonSplitStepScopeLabel(value) }}
                            </div>
                            <div v-if="!isSortedStepFlow || isGroupInCurrentLogicalStep(value)" class="addon-box" >
                                <div :class="['price-item-addon','price-item-addon--row',{'price-item-active': !!item.beingChoose || getAddonItemQty(item) > 0, 'price-item-locked': !isGroupUnlockedBySortedIndex(value)}]"
                                    @click="chooseAddon(value.__sourceIndex, item.__sourceIndex, value)"
                                    :key="'main-opt-' + value.__sourceIndex + '-' + (item.subItemId || item.id || item.__sourceIndex) + '-' + itemIdx"
                                    v-for="(item, itemIdx) in getVisibleAddonItems(value, value.__sourceIndex)" >
                                    <span class="addon-row-left">
                                        <span class="addon-row-indicator" :class="{ 'is-on': !!item.beingChoose || getAddonItemQty(item) > 0 }"></span>
                                        <span class="addon-row-name">{{ item.subItemName }}</span>
                                    </span>
                                    <span class="addon-row-price">+{{ currencySign }}{{ getAddonDisplayPrice(value, item) }}</span>
                                    <span v-if="Number(value.allowQty || 0) === 1" class="addon-qty-wrap" @click.stop>
                                        <button class="addon-qty-btn" type="button" @click.stop="changeAddonQty(value.__sourceIndex, item.__sourceIndex, -1, value)">-</button>
                                        <span class="addon-qty-num">{{ getAddonItemQty(item) }}</span>
                                        <button class="addon-qty-btn" type="button" @click.stop="changeAddonQty(value.__sourceIndex, item.__sourceIndex, 1, value)">+</button>
                                    </span>
                                </div>
                            </div>
                            <!-- addonSort：不展示上一步 summary，只显示当前步骤 -->
                            <div v-else class="step-summary-box" style="display:none;"></div>
                        </li>
                    </ul>
                    <!-- 配菜 无价格（addonSort 分步时仅最后一步展示，与后台预览一致） -->
                    <div class="addon-title" v-if="foodDetails.ingredientsList && foodDetails.ingredientsList.length>0 && (!isSortedStepFlow || isLastSortedStep)">{{i18n.AddonItem}}</div>
                    <div class="addon-box" v-if="foodDetails.ingredientsList && foodDetails.ingredientsList.length>0 && (!isSortedStepFlow || isLastSortedStep)" >
                        <div :class="['price-item-addon','price-item-addon--row',{'price-item-active':nowChooseIdent.includes(item.ingredientsId)}]"
                            v-for="(item) in foodDetails.ingredientsList"  :key="item.ingredientsId" @click="chooseIdent(item)" >
                            <span class="addon-row-left">
                                <span class="addon-row-indicator" :class="{ 'is-on': nowChooseIdent.includes(item.ingredientsId) }"></span>
                                <span class="addon-row-name">{{ item.ingredientsName }}</span>
                            </span>
                        </div>
                    </div>
                    
                    <!-- 口味 烹饪参考 -->
                    <div class="addon-title" v-if="foodDetails.cookingRefList&&foodDetails.cookingRefList.length>0 && (!isSortedStepFlow || isLastSortedStep)">{{i18n.Cuise}}</div>
                    <div class="addon-box" v-if="foodDetails.cookingRefList&&foodDetails.cookingRefList.length>0 && (!isSortedStepFlow || isLastSortedStep)" >
                        <div :class="['price-item-addon','price-item-addon--row',{'price-item-active':nowCookingRef.includes(item.cookId)}]"
                            v-for="(item) in foodDetails.cookingRefList" :key="item.cookId" @click="chooseCookingRef(item)" >
                            <span class="addon-row-left">
                                <span class="addon-row-indicator" :class="{ 'is-on': nowCookingRef.includes(item.cookId) }"></span>
                                <span class="addon-row-name">{{ item.cookingName }}</span>
                            </span>
                        </div>
                    </div>
                </template>
                <div
                    v-if="showModal && !loadingFood && showFloatingSelectionBar"
                    class="modal-floating-selection modal-floating-selection--selection-summary"
                >
                    <div
                        ref="floatingSelectionSummaryLines"
                        :class="['modal-floating-selection__lines-wrap', { 'is-collapsed': !floatingSelectionMeasuring && floatingSelectionSummaryExpandable && !floatingSelectionSummaryExpanded }]"
                    >
                        <div v-if="floatingSelectionSizeLine" class="modal-floating-selection__line">{{ floatingSelectionSizeLine }}</div>
                        <div
                            v-for="(g, gi) in floatingSelectionAddonGroups"
                            :key="'fs-addon-' + gi"
                            class="modal-floating-selection__line"
                        >
                            <span class="modal-floating-selection__line-title">{{ g.title }}: </span><span class="modal-floating-selection__line-value">{{ g.body }}</span>
                        </div>
                    </div>
                    <button
                        v-if="floatingSelectionSummaryExpandable"
                        type="button"
                        class="modal-floating-selection__toggle"
                        @click.stop="floatingSelectionSummaryExpanded = !floatingSelectionSummaryExpanded"
                    >
                        {{ floatingSelectionSummaryExpanded ? 'Show less' : 'Show more' }}
                    </button>
                </div>
            </div>
            <span slot="footer" class="modal-footer">
                <div class="modal-footer-total">
                    <span>Total</span>
                    <strong>{{ currencySign }}{{ getTotalPrice() }}</strong>
                </div>
                <el-button
                    v-if="isSortedStepFlow && sortedFlowTotalSteps > 1"
                    :size="isMobile ? 'small' : 'medium'"
                    @click="prevStep"
                    :disabled="!hasPrevLogicalStep()"
                >
                    Back
                </el-button>
                <el-button
                    type="primary"
                    :size="isMobile ? 'small' : 'medium'"
                    style="background-color: #aa0bc0;"
                    @click="handleMainFoodModalPrimary"
                    :loading="!(isSortedStepFlow && !isLastSortedStep) && (foodDetails.itemId == addCartLoading || loadingFood)"
                    :disabled="loadingFood"
                >
                    <span>{{ isSortedStepFlow && !isLastSortedStep ? 'Next' : 'Add to basket' }}</span>
                </el-button>
            </span>
        </el-dialog>

        <!-- FreeItem 弹窗内容展示 -->
        <el-dialog
            :visible.sync="freeItemModal"
            :width="isMobile?'90%':'30%'"
            custom-class="food-detail-dialog food-detail-dialog--freeitem"
            :before-close="handleClose">
            <div style="padding-right:20px;" class="free-item-modal">
                <div class="modal-img">
                    <img class="alleat-icon" src="https://assets.alleatapp.com/images/20230630/3132D06D81338CD68E254687658C5D0C.png" mode="widthFix" />
                </div>
                <div v-for="foodInfo in freeItemList" :key="foodInfo.itemId" >
                    <div class="modal-desc modal-desc-bold">
                        Nice! You get this free with your order
                    </div>
                    <div class="modal-desc">
                        We'll apply the discount at checkout
                    </div>
                    <div class="modal-desc modal-desc-name" v-if="!foodInfo.photo">
                        "{{ foodInfo.itemName }}"
                    </div>
                    <template v-else>
                        <div class="modal-desc modal-desc-bold modal-desc-name-normal">
                            "{{ foodInfo.itemName }}"
                        </div>
                        <div class="modal-food-img">
                            <img :src="foodInfo.photo" mode="aspectFill" />
                        </div>
                    </template>
                    <div class="modal-content" style="margin-top: 10px;" :class="['foodtag-mode-' + getFoodTagMode()]">
                        <!-- <div class="price-title" >Specifications</div>
                        <ul>
                            <li v-for="(price,ind) in foodInfo.foodSkuPriceList" :key="ind" @click="nowChoosePrice(price, ind)"
                                :class="['price-item',{'price-item-active': String(nowPrice.sizeId) === String(price.sizeId)}]">
                                <span>{{ price.sizeName }}</span>
                                <span>{{ currencySign + price.foodPrice }}</span>
                            </li>
                        </ul> -->
                        <div class="dash-row" v-if="showAddonTitle"></div>
                        <div class="price-title" v-if="showAddonTitle">Additional items</div>
                        <div
                            v-if="isSortedStepFlow && sortedFlowTotalSteps > 0"
                            class="addon-sort-progress-track"
                            role="progressbar"
                            :aria-valuenow="addonSortProgressPercent"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            <div class="addon-sort-progress-fill" :style="{ width: addonSortProgressPercent + '%' }"></div>
                        </div>
                        <div
                            v-if="showSortedSplitTabsArea && currentSortedAddonGroup && splitAddonUiBundleKey(currentSortedAddonGroup)"
                            class="addon-split-mode-tabs addon-split-mode-tabs--step-header"
                        >
                            <button
                                type="button"
                                class="addon-split-mode-btn"
                                :class="{ 'is-active': getAddonSplitUiBranch(splitAddonUiBundleKey(currentSortedAddonGroup)) === 'whole' }"
                                @click="setAddonSplitBranch(splitAddonUiBundleKey(currentSortedAddonGroup), 'whole')"
                            >
                                Entire item
                            </button>
                            <button
                                type="button"
                                class="addon-split-mode-btn"
                                :class="{ 'is-active': getAddonSplitUiBranch(splitAddonUiBundleKey(currentSortedAddonGroup)) === 'portion' }"
                                @click="setAddonSplitBranch(splitAddonUiBundleKey(currentSortedAddonGroup), 'portion')"
                            >
                                Split portions
                            </button>
                        </div>
                        <div class="food-loading" v-if="loadingFood">
                            <i class="el-icon-loading" ></i>
                        </div>
                        <template v-else>
                            <!-- 有价格 的 addon -->
                            <ul v-if="previewAddonGroupsVisible && previewAddonGroupsVisible.length">
                                <li
                                    v-for="(value, key) in previewAddonGroupsVisible"
                                    :key="splitAddonGroupKey(value, value.__sourceIndex, 'free')"
                                    v-show="!isSortedStepFlow || isGroupInCurrentLogicalStep(value)"
                                >
                                    <div
                                        v-if="!isSortedStepFlow && splitAddonUiBundleKey(value) && (value.__splitBranchType === 'whole' || (value.__splitBranchType === 'portion' && Number(value.__splitPreviewSlotIndex) === 0))"
                                        class="addon-split-mode-tabs"
                                    >
                                        <button
                                            type="button"
                                            class="addon-split-mode-btn"
                                            :class="{ 'is-active': getAddonSplitUiBranch(splitAddonUiBundleKey(value)) === 'whole' }"
                                            @click="setAddonSplitBranch(splitAddonUiBundleKey(value), 'whole')"
                                        >
                                            Entire item
                                        </button>
                                        <button
                                            type="button"
                                            class="addon-split-mode-btn"
                                            :class="{ 'is-active': getAddonSplitUiBranch(splitAddonUiBundleKey(value)) === 'portion' }"
                                            @click="setAddonSplitBranch(splitAddonUiBundleKey(value), 'portion')"
                                        >
                                            Split portions
                                        </button>
                                    </div>
                                    <div class="addon-title">
                                        {{ getAddonGroupName(value) }}
                                        ({{[0,1].includes(value.selectType)?'Single Choice':'Multiple Select'}}  {{value.required?'| '+ 'required':''}}) 
                                        <span v-if="value.selectType==3" >Max choose {{value.customSize}}</span>
                                        <span class="addon-meta-tag" v-if="Number(foodDetails.addonSort || 0) === 1">#{{ getAddonSortIndex(value, key) }}</span>
                                        <span
                                          v-if="Number(foodDetails.addonSort || 0) === 1"
                                          :class="['addon-step-state', 'is-' + getStepStatusBySortedIndex(value)]"
                                        >
                                          {{ getStepStatusBySortedIndex(value) === 'current' ? 'Current' : (getStepStatusBySortedIndex(value) === 'done' ? 'Done' : 'Locked') }}
                                        </span>
                                        <span class="addon-meta-tag" v-if="Number(value.freeLimit || 0) === 1">first {{ value.freeLimitCount || 0 }} free</span>
                                        <span class="addon-meta-tag" v-if="Number(value.sizePrice || 0) === 1">size price</span>
                                        <span class="addon-meta-tag" v-if="Number(value.allowQty || 0) === 1">qty selectable</span>
                                    </div>
                                    <div
                                        v-if="isSortedStepFlow && isGroupInCurrentLogicalStep(value) && addonSplitStepScopeLabel(value)"
                                        class="addon-split-step-scope"
                                    >
                                        {{ addonSplitStepScopeLabel(value) }}
                                    </div>
                                    <div v-if="!isSortedStepFlow || isGroupInCurrentLogicalStep(value)" class="addon-box" >
                                        <div :class="['price-item-addon','price-item-addon--row',{'price-item-active': !!item.beingChoose || getAddonItemQty(item) > 0, 'price-item-locked': !isGroupUnlockedBySortedIndex(value)}]"
                                            @click="chooseAddon(value.__sourceIndex, item.__sourceIndex, value)"
                                            :key="'free-opt-' + value.__sourceIndex + '-' + (item.subItemId || item.id || item.__sourceIndex) + '-' + itemIdx"
                                            v-for="(item, itemIdx) in getVisibleAddonItems(value, value.__sourceIndex)" >
                                            <span class="addon-row-left">
                                                <span class="addon-row-indicator" :class="{ 'is-on': !!item.beingChoose || getAddonItemQty(item) > 0 }"></span>
                                                <span class="addon-row-name">{{ item.subItemName }}</span>
                                            </span>
                                            <span class="addon-row-price">+{{ currencySign }}{{ getAddonDisplayPrice(value, item) }}</span>
                                            <span v-if="Number(value.allowQty || 0) === 1" class="addon-qty-wrap" @click.stop>
                                                <button class="addon-qty-btn" type="button" @click.stop="changeAddonQty(value.__sourceIndex, item.__sourceIndex, -1, value)">-</button>
                                                <span class="addon-qty-num">{{ getAddonItemQty(item) }}</span>
                                                <button class="addon-qty-btn" type="button" @click.stop="changeAddonQty(value.__sourceIndex, item.__sourceIndex, 1, value)">+</button>
                                            </span>
                                        </div>
                                    </div>
                                    <!-- addonSort：不展示上一步 summary，只显示当前步骤 -->
                                    <div v-else class="step-summary-box" style="display:none;"></div>
                                </li>
                            </ul>
                            <!-- 配菜 无价格 -->
                            <div class="addon-title" v-if="foodDetails.ingredientsList && foodDetails.ingredientsList.length>0 && (!isSortedStepFlow || isLastSortedStep)">{{i18n.AddonItem}}</div>
                            <div class="addon-box" v-if="foodDetails.ingredientsList && foodDetails.ingredientsList.length>0 && (!isSortedStepFlow || isLastSortedStep)" >
                                <div :class="['price-item-addon','price-item-addon--row',{'price-item-active':nowChooseIdent.includes(item.ingredientsId)}]"
                                    v-for="(item) in foodDetails.ingredientsList"  :key="item.ingredientsId" @click="chooseIdent(item)" >
                                    <span class="addon-row-left">
                                        <span class="addon-row-indicator" :class="{ 'is-on': nowChooseIdent.includes(item.ingredientsId) }"></span>
                                        <span class="addon-row-name">{{ item.ingredientsName }}</span>
                                    </span>
                                </div>
                            </div>
                            
                            <!-- 口味 烹饪参考 -->
                            <div class="addon-title" v-if="foodDetails.cookingRefList && foodDetails.cookingRefList.length>0 && (!isSortedStepFlow || isLastSortedStep)">{{i18n.Cuise}}</div>
                            <div class="addon-box" v-if="foodDetails.cookingRefList && foodDetails.cookingRefList.length>0 && (!isSortedStepFlow || isLastSortedStep)" >
                                <div :class="['price-item-addon','price-item-addon--row',{'price-item-active':nowCookingRef.includes(item.cookId)}]"
                                    v-for="(item) in foodDetails.cookingRefList" :key="item.cookId" @click="chooseCookingRef(item)" >
                                    <span class="addon-row-left">
                                        <span class="addon-row-indicator" :class="{ 'is-on': nowCookingRef.includes(item.cookId) }"></span>
                                        <span class="addon-row-name">{{ item.cookingName }}</span>
                                    </span>
                                </div>
                            </div>
                        </template>
                        <div
                            v-if="freeItemModal && !loadingFood && showFloatingSelectionBar"
                            class="modal-floating-selection modal-floating-selection--selection-summary"
                        >
                            <div
                                ref="floatingSelectionSummaryLinesFree"
                                :class="['modal-floating-selection__lines-wrap', { 'is-collapsed': !floatingSelectionMeasuring && floatingSelectionSummaryExpandable && !floatingSelectionSummaryExpanded }]"
                            >
                                <div v-if="floatingSelectionSizeLine" class="modal-floating-selection__line">{{ floatingSelectionSizeLine }}</div>
                                <div
                                    v-for="(g, gi) in floatingSelectionAddonGroups"
                                    :key="'fs-free-addon-' + gi"
                                    class="modal-floating-selection__line"
                                >
                                    <span class="modal-floating-selection__line-title">{{ g.title }}: </span><span class="modal-floating-selection__line-value">{{ g.body }}</span>
                                </div>
                            </div>
                            <button
                                v-if="floatingSelectionSummaryExpandable"
                                type="button"
                                class="modal-floating-selection__toggle"
                                @click.stop="floatingSelectionSummaryExpanded = !floatingSelectionSummaryExpanded"
                            >
                                {{ floatingSelectionSummaryExpanded ? 'Show less' : 'Show more' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="modal-footer modal-footer--free-step">
                <el-button
                    v-if="isSortedStepFlow && sortedFlowTotalSteps > 1"
                    :size="isMobile ? 'small' : 'medium'"
                    @click="prevStep"
                    :disabled="!hasPrevLogicalStep()"
                >
                    Back
                </el-button>
                <el-button
                    type="primary"
                    :size="isMobile ? 'small' : 'medium'"
                    style="background-color: #aa0bc0; flex: 1;"
                    @click="handleFreeItemModalPrimary"
                    :loading="!(isSortedStepFlow && !isLastSortedStep) && (foodDetails.itemId == addCartLoading || loadingFood)"
                    :disabled="loadingFood"
                >
                    <span>{{ isSortedStepFlow && !isLastSortedStep ? 'Next' : 'Add to basket' }}</span>
                </el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import { postGateway } from '@/request';
export default {
    model: {
        prop: 'showSearchCover',
        handle: 'input'
    },
    props: {
        info: {
            type: Object,
            default: () => {
                return {
                    deliveryDistance: ''
                }
            }
        },
        currencySign: {
            type: String,
            default: () => ''
        },
        categoryList: {
            type: Array,
            default: () => []
        },
        foodList: {
            type: Array,
            default: () => []
        },
        cartList: {
            type: Array,
            default: () => []
        },
        MaxShopPrice: {
            type: Number,
            default: () => 99999
        },
        showSearchCover: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        showAddonTitle() {
            const fd = this.foodDetails || {};
            return (fd.addOnInfoList || []).length || (fd.ingredientsList || []).length || (fd.cookingRefList || []).length;
        },
        previewAddonGroups() {
            const list = (this.foodDetails && this.foodDetails.addOnInfoList) || [];
            const addonSort = Number((this.foodDetails && this.foodDetails.addonSort) || 0);
            const mapped = list.map((group, idx) => ({
                ...group,
                __sourceIndex: idx
            }));
            if (addonSort !== 1) return mapped;
            return mapped.sort((a, b) => {
                const sa = Number(a.sortIndex || 0);
                const sb = Number(b.sortIndex || 0);
                if (!sa && !sb) return a.__sourceIndex - b.__sourceIndex;
                if (!sa) return 1;
                if (!sb) return -1;
                if (sa === sb) return a.__sourceIndex - b.__sourceIndex;
                return sa - sb;
            });
        },
        isMobile() {
            return window.innerWidth < 950
        },
        deliveryDistance() {
            let result = this.info.deliveryDistance;
            if(!result.includes('miles')) {
                result = result.replace('mile', 'miles')
            }
            return result.includes('null')? '' : result
        },
        isSortedStepFlow() {
            return Number(this.foodDetails && this.foodDetails.addonSort) === 1
        },
        /** 同一 split 组内只展示当前选中的分支（整份 vs 各分份），避免叠成三列 */
        previewAddonGroupsVisible() {
            const list = this.previewAddonGroups || [];
            return list.filter(g => this.isAddonSplitBranchVisible(g));
        },
        /** 与后台预览一致：addonSort 时第一步选规格（主弹窗；FreeItem 弹窗无规格 UI 则不占步） */
        sortedFlowHasSizeStep() {
            if (!this.isSortedStepFlow) return false;
            if (this.freeItemModal) return false;
            const list = this.foodDetails && this.foodDetails.foodSkuPriceList;
            return !!(list && list.length);
        },
        /** 总步数 = 规格步（如有）+ 每个可见 addon 分组各一步 */
        sortedFlowTotalSteps() {
            if (!this.isSortedStepFlow) return 0;
            const vis = this.previewAddonGroupsVisible || [];
            return vis.length + (this.sortedFlowHasSizeStep ? 1 : 0);
        },
        /** 当前对应的可见 addon 分组下标；规格步时为 -1 */
        currentAddonSortedIndex() {
            if (!this.isSortedStepFlow) return -1;
            if (this.sortedFlowHasSizeStep) return this.currentStepIndex - 1;
            return this.currentStepIndex;
        },
        isLastSortedStep() {
            if (!this.isSortedStepFlow) return true;
            const last = this.sortedFlowTotalSteps - 1;
            if (last < 0) return true;
            return this.currentStepIndex >= last;
        },
        shouldShowMainModalSkuPicker() {
            if (!this.showModal) return false;
            const list = this.nowChooseFood && this.nowChooseFood.foodSkuPriceList;
            if (!list || !list.length) return false;
            if (!this.isSortedStepFlow) return true;
            if (!this.sortedFlowHasSizeStep) return true;
            return this.currentStepIndex === 0;
        },
        /** 主弹窗中是否显示加料区（规格步时隐藏，与后台分步一致） */
        mainModalAddonBodyVisible() {
            if (!this.isSortedStepFlow) return true;
            if (!this.sortedFlowHasSizeStep) return true;
            return this.currentStepIndex > 0;
        },
        addonSortProgressPercent() {
            if (!this.isSortedStepFlow) return 0;
            const n = this.sortedFlowTotalSteps;
            if (!n) return 0;
            return Math.min(100, Math.round(((this.currentStepIndex + 1) / n) * 100));
        },
        /** 与后台预览一致：addonSort 当前步对应的可见分组（用于整份/分份 Tab） */
        currentSortedAddonGroup() {
            if (!this.isSortedStepFlow) return null;
            const i = this.currentAddonSortedIndex;
            if (i < 0) return null;
            const vis = this.previewAddonGroupsVisible || [];
            return vis[i] || null;
        },
        /** 底部已选规格：与 App 一致，单规格也展示一行 `Size: …` */
        floatingSelectionSizeLine() {
            if (!(this.showModal || this.freeItemModal) || this.loadingFood) return '';
            const skus = this.nowChooseFood && this.nowChooseFood.foodSkuPriceList;
            if (!skus || !skus.length) return '';
            const p = this.nowPrice;
            if (!p) return '';
            const sn = (p.sizeName != null && p.sizeName !== '') ? p.sizeName : p.sizeId;
            if (sn === undefined || sn === null || String(sn).trim() === '') return '';
            return `Size: ${sn}`;
        },
        /** 底部已选：按分组拆开，避免多组连成一串 */
        floatingSelectionAddonGroups() {
            if (!(this.showModal || this.freeItemModal) || this.loadingFood) return [];
            const fd = this.foodDetails;
            if (!fd || !Array.isArray(fd.addOnInfoList)) return [];
            const out = [];
            fd.addOnInfoList.forEach((group, gi) => {
                if (!this.isAddonSplitBranchVisible(group)) return;
                const vis = this.getVisibleAddonItems(group, group.__sourceIndex != null ? group.__sourceIndex : gi);
                const parts = [];
                vis.forEach(item => {
                    const q = this.getAddonPayloadQty(group, item);
                    if (q <= 0) return;
                    const nm = (item.subItemName || item.name || '').toString().trim() || 'Option';
                    parts.push(q > 1 ? `${nm} ×${q}` : nm);
                });
                if (!parts.length) return;
                const title = (this.getAddonGroupName(group) || '').trim();
                out.push({
                    title: title || 'Add-ons',
                    body: parts.join(', '),
                });
            });
            return out;
        },
        showFloatingSelectionBar() {
            return !!(this.floatingSelectionSizeLine || this.floatingSelectionAddonGroups.length);
        },
        /** 分步流程中是否处于「加料区」：主弹窗规格步之后，或 FreeItem 弹窗（无规格步） */
        showSortedSplitTabsArea() {
            if (!this.isSortedStepFlow || this.loadingFood) return false;
            if (this.showModal && this.mainModalAddonBodyVisible) return true;
            if (this.freeItemModal) {
                if (!this.sortedFlowHasSizeStep) return true;
                return this.currentStepIndex > 0;
            }
            return false;
        }
    },
    data() {
        return {
            clientId:  localStorage.getItem('clientId'),
            searchResult: [],
            searchLoading: true,
            nowChooseFood: {
                itemName: '',
                foodSkuPriceList: [],
                isAddon: 0,  // 是否有附加物品
            },
            nowPrice: {
                foodPrice: '',
                sizeId: ''
            },
            showModal: false,
            foodDetails: {
                addOnInfoList: [],
                ingredientsList: [],
                cookingRefList: [],
                itemId: null
            },
            nowChooseIdent: [],
            nowCookingRef: [],
            loadingFood: false,
            nowChoose: 0,
            addCartLoading: null,
            freeItemModal: false,
            freeItemList: [], // freeItem 内容
            /** splitConfig：整份 / 分部位 UI 模式，key 为 __splitBundleId */
            addonSplitUiBranch: {},
            currentStepIndex: 0,
            /** freeLimit：记录用户选择顺序（含 allowQty 每次 +1） */
            addonSelectSeq: 1,
            /** 底部已选摘要：超出高度可展开（主 / Free 共用，同时只开一个弹窗） */
            floatingSelectionSummaryExpanded: false,
            floatingSelectionSummaryExpandable: false,
            /** 测量全高时暂时取消折叠，避免与 is-collapsed 冲突 */
            floatingSelectionMeasuring: false,
        }
    },
    mounted() {
    },
    watch: {
        showFloatingSelectionBar(val) {
            if (val) {
                this.floatingSelectionSummaryExpanded = false;
                this.measureFloatingSelectionSummary();
            } else {
                this.floatingSelectionSummaryExpandable = false;
            }
        },
        floatingSelectionSizeLine() {
            this.floatingSelectionSummaryExpanded = false;
            this.measureFloatingSelectionSummary();
        },
        floatingSelectionAddonGroups: {
            deep: true,
            handler() {
                this.floatingSelectionSummaryExpanded = false;
                this.measureFloatingSelectionSummary();
            },
        },
        loadingFood(val) {
            if (!val && (this.showModal || this.freeItemModal)) {
                this.measureFloatingSelectionSummary();
            }
        },
    },
    methods: {
        measureFloatingSelectionSummary() {
            this.floatingSelectionMeasuring = true;
            this.$nextTick(() => {
                const raw = this.showModal
                    ? this.$refs.floatingSelectionSummaryLines
                    : this.$refs.floatingSelectionSummaryLinesFree;
                const el = Array.isArray(raw) ? raw[0] : raw;
                const full = el && typeof el.scrollHeight === 'number' ? el.scrollHeight : 0;
                this.floatingSelectionMeasuring = false;
                const maxPx = 80;
                this.floatingSelectionSummaryExpandable = full > maxPx + 1;
                if (!this.floatingSelectionSummaryExpandable) {
                    this.floatingSelectionSummaryExpanded = false;
                }
            });
        },
        nextAddonSelectSeq() {
            const n = Number(this.addonSelectSeq || 1)
            const next = Number.isNaN(n) ? 1 : n + 1
            this.addonSelectSeq = next
            return next
        },
        clearAddonSelectionSeqForItem(item) {
            if (!item) return
            item.__selectSeq = undefined
            item.__selectSeqs = undefined
        },
        clearAddonSelectionSeqForGroup(group) {
            if (!group || !Array.isArray(group.subItemList)) return
            group.subItemList.forEach(it => this.clearAddonSelectionSeqForItem(it))
        },
        /** allowQty=0：选中时给单份 seq；allowQty=1：每份 qty 都有 seq（数组） */
        applyAddonSelectionSeq(group, item, mode, delta) {
            if (!group || !item) return
            if (Number(group.allowQty || 0) === 1) {
                if (!Array.isArray(item.__selectSeqs)) item.__selectSeqs = []
                const d = Number(delta || 0)
                if (d > 0) {
                    for (let i = 0; i < d; i++) item.__selectSeqs.push(this.nextAddonSelectSeq())
                } else if (d < 0) {
                    for (let i = 0; i < Math.abs(d); i++) item.__selectSeqs.pop()
                }
                if (!item.__selectSeqs.length) item.__selectSeqs = undefined
                return
            }
            if (mode === 'select') item.__selectSeq = this.nextAddonSelectSeq()
            if (mode === 'unselect') item.__selectSeq = undefined
        },
        // 设置 freeItem 并且弹出弹窗
        setFreeItemModal(list) {
            this.freeItemList = list;
            this.freeItemModal = true;
            let item = list[0]
            this.nowChooseFood = item;
            this.foodDetails.itemId = item.itemId;
            this.getFoodDetails(item)
        },
        // 添加FreeItem 进入购物车
        addFreeItemIntoCard() {
            if(this.addCartLoading || this.loadingFood) {
                return
            }
            this.normalizeAddonVisibility();
            if (this.isSortedStepFlow && this.sortedFlowTotalSteps > 0 && !this.isLastSortedStep) {
                this.$message.info('Please finish all steps before adding to basket');
                return;
            }
			
            this.clientId = localStorage.getItem('clientId');

            let item = this.nowChooseFood;
            if(this.nowChooseFood.isAddon || item.foodSkuPriceList.length>1) {
                item = this.foodDetails;
            }

            // 校验 addon 是否合法
            if(!this.judgeAddonCanAdd(this.nowChooseFood) && this.nowChooseFood.isAddon) {
                this.$message.info('Please choose the Additional items')
                return
            }

			let param = {
				categoryId: item.catId,
				qty: 1,  // 新增传1
				price: 0,
                chooseItems: item.foodSkuPriceList[this.nowChoose].sizeName,
                itemName: item.itemName,
				itemId: item.itemId,
				merchantId: this.info.merchantId,
                clientId: this.clientId,
				foodSkuId: item.foodSkuPriceList[this.nowChoose].foodSkuId,
				cookingRef: [],	// 烹饪参考
				ingredients: [], // 配菜
				subItems: [],// 附加物品
			}
			
			// 处理附加物品
			if(item.addOnInfoList) {
				item.addOnInfoList.forEach((cate)=>{
                    // freeLimit 支持：展开逐份并标记 isFree
                    const rows = this.buildSubItemPayloadRowsForGroup(cate);
                    rows.forEach(r => param.subItems.push(r));
				})
			}
			
			// 处理烹饪类型 口味
			param.cookingRef = this.nowChooseIdent;
			
			// 处理 配菜
			param.ingredients = this.nowCookingRef;

            // offId 只有 freeItem 有这个字段
            param.offId = this.nowChooseFood.offId;
            param.overFlag = this.nowChooseFood.overFlag;
            param.freeitemFlag = 1;
            param.offAmountLimit = this.nowChooseFood.offAmountLimit;  // 标记当前的freeItem 加入购物车的限制金额

            this.checkToCart(param).then((res)=>{
                this.applyServerTotalPriceToParam(param, res);
                this.$emit('addCart', param, 'sku')
                param.qty = 1; // 新增赋值为1
                this.freeItemModal = false;
                this.addCartLoading = null;
                this.handleClose();
            })
            .catch((err)=>{
                console.log(err,'err')
                this.addCartLoading = null;
                this.$message.error(err.msg)
            })
			
			console.log(param,'加入购物车回参')
        },
        // 校验是否能加入购物车
        checkToCart(param) {
            this.addCartLoading = param.itemId;
            let ids = this.cartList.map(x=>x.itemId)
            let checkParam = {
                ...param
            }
            if(ids.includes(param.itemId)) {
                checkParam.qty++;
            }
            return postGateway({
                url: '/customerApp/cart/checkAddAppCart',
                data: {
                    ...checkParam,
                    merchantId: this.info.merchantId
                }
            })
        },
        /** checkAddAppCart 等接口若在 data 中返回 totalPrice，则以此为准写入 param.totalPrice（以接口计价为准） */
        applyServerTotalPriceToParam(param, res) {
            if (!param || !res || !res.data) return;
            if (Number(param.freeitemFlag) === 1) return;
            const raw = res.data.totalPrice;
            if (raw === undefined || raw === null || raw === '') return;
            const n = Number(raw);
            if (Number.isNaN(n)) return;
            // 只同步 totalPrice，避免改动 price 引起二次计价/监听循环
            param.totalPrice = Math.round(n * 100) / 100;
        },
        getTotalPrice() {  // 计算弹窗情况的价格
			let price = 0;
			if(this.foodDetails.addOnInfoList && this.foodDetails.addOnInfoList.length > 0) {
				price = this.foodDetails.foodSkuPriceList?this.foodDetails.foodSkuPriceList[this.nowChoose].foodPrice:0;
				this.foodDetails.addOnInfoList.forEach((cate)=>{
                    price = price * 1 + this.getGroupSelectedAddonTotal(cate);
				})
			} else {
				price = this.foodDetails.foodSkuPriceList?this.foodDetails.foodSkuPriceList[this.nowChoose].foodPrice:0
			}
			return price.toFixed(2);
		},
        // 判断 addon 是否合法（selectType==3：customSize 为「总份数」上限；分份池内按所有 split 行 qty 总和与 customSize 比较）
        judgeAddonCanAdd() {
            let judge = true
            const processedPools = new Set()

            this.foodDetails.addOnInfoList.forEach((ele, ind1) => {
                if (ele.selectType == 3 && ele.required == 1 && this.foodDetails.addOnInfoList[ind1].customSize * 1 > 1) {
                    const peerIdxs = this.getSplitSharedPortionPeerIndicies(ele)
                    if (peerIdxs) {
                        const poolKey = this.splitAddonUiBundleKey(ele)
                        if (processedPools.has(poolKey)) return
                        processedPools.add(poolKey)
                        let units = 0
                        const list = this.foodDetails.addOnInfoList || []
                        peerIdxs.forEach(gi => {
                            const g = list[gi]
                            ;(g.subItemList || []).forEach(subItem => {
                                units += this.getAddonPayloadQty(g, subItem)
                            })
                        })
                        let need = this.foodDetails.addOnInfoList[ind1].customSize * 1
                        const capPool = this.getSplitPortionSharedPickCap(ele)
                        if (capPool !== Infinity && Number.isFinite(capPool)) {
                            need = Math.min(need, capPool)
                        }
                        if (units != need) judge = false
                    } else {
                        let units = 0
                        ;(ele.subItemList || []).forEach(subItem => {
                            units += this.getAddonPayloadQty(ele, subItem)
                        })
                        if (units != this.foodDetails.addOnInfoList[ind1].customSize * 1) {
                            judge = false
                        }
                    }
                }
            })

            return judge
        },
        handleMainFoodModalPrimary() {
            if (this.isSortedStepFlow && !this.isLastSortedStep) {
                this.handleNextStepClick();
                return;
            }
            this.addSkuToCart();
        },
        handleFreeItemModalPrimary() {
            if (this.isSortedStepFlow && !this.isLastSortedStep) {
                this.handleNextStepClick();
                return;
            }
            this.addFreeItemIntoCard();
        },
        // sku 加入购物车
        addSkuToCart() {
            if(this.addCartLoading) {
                return
            }
            this.normalizeAddonVisibility();
            if (this.isSortedStepFlow && this.sortedFlowTotalSteps > 0 && !this.isLastSortedStep) {
                this.$message.info('Please finish all steps before adding to basket');
                return;
            }
			// if((item.foodSkuPriceList[this.nowChoose].foodPrice *1 + this.nowTotalPrice*1) > this.MaxShopPrice) {
			// 	this.$message.info('Over max shop price')
			// 	return
			// }
            this.clientId = localStorage.getItem('clientId');

            let item = this.nowChooseFood;
            if(this.nowChooseFood.isAddon || item.foodSkuPriceList.length>1) {
                item = this.foodDetails;
            }

            // 校验 addon 是否合法
            if(!this.judgeAddonCanAdd(this.nowChooseFood) && this.nowChooseFood.isAddon) {
                this.$message.info('Please choose the Additional items')
                return
            }

			let param = {
				categoryId: item.catId,
				qty: 1,  // 新增传1
				price: this.getTotalPrice() || item.foodSkuPriceList[this.nowChoose].foodPrice,
                chooseItems: item.foodSkuPriceList[this.nowChoose].sizeName,
                itemName: item.itemName,
				itemId: item.itemId,
				merchantId: this.info.merchantId,
                clientId: this.clientId,
				foodSkuId: item.foodSkuPriceList[this.nowChoose].foodSkuId,
				cookingRef: [],	// 烹饪参考
				ingredients: [], // 配菜
				subItems: [],// 附加物品
			}
			
			// 处理附加物品
			if(item.addOnInfoList) {
				item.addOnInfoList.forEach((cate)=>{
                    // freeLimit 支持：展开逐份并标记 isFree
                    const rows = this.buildSubItemPayloadRowsForGroup(cate);
                    rows.forEach(r => param.subItems.push(r));
				})
			}
			
			// 处理烹饪类型 口味
			param.cookingRef = this.nowChooseIdent;
			
			// 处理 配菜
			param.ingredients = this.nowCookingRef;
			
			console.log(param,'加入购物车回参')
			// return

            this.checkToCart(param).then((res)=>{
                this.applyServerTotalPriceToParam(param, res);
                this.$emit('addCart', param, 'sku')
                param.qty = 1; // 新增赋值为1
                this.showModal = false;
                this.addCartLoading = null;
                this.handleClose();
            })
            .catch((err)=>{
                console.log(err,'err')
                this.addCartLoading = null;
                this.$message.error(err.msg)
            })
        },
        // 选择附加物品
		chooseAddon(ind1,ind2,sortedGroupIdx=-1) {
            if(!this.isGroupUnlockedBySortedIndex(sortedGroupIdx)) {
                return
            }
            const group = this.foodDetails.addOnInfoList[ind1];
            const target = group && group.subItemList ? group.subItemList[ind2] : null;
            if (!group || !target) return;
            this.ensureAddonSplitBranchForGroup(group);
            if (Number(group.allowQty || 0) === 1) {
                const nowQty = this.getAddonItemQty(target);
                this.changeAddonQty(ind1, ind2, nowQty > 0 ? -nowQty : 1, sortedGroupIdx);
                return;
            }
			if(!this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose && [0,1].includes(this.foodDetails.addOnInfoList[ind1].selectType)) {  // 单选物品
                const grpSingle = this.foodDetails.addOnInfoList[ind1];
                if (this.isSplitSharedPoolRow(grpSingle)) {
                    const capS = this.getSplitPortionSharedPickCap(grpSingle);
                    if (capS !== Infinity && this.getSplitPoolSelectedOptionCountExcludingGroup(grpSingle) + 1 > capS) {
                        this.notifySplitPoolCapReachedMenuBox();
                        return;
                    }
                }
                this.foodDetails.addOnInfoList[ind1].subItemList.forEach((ele,ind)=>{
					this.foodDetails.addOnInfoList[ind1].subItemList[ind].beingChoose = false;
                    this.foodDetails.addOnInfoList[ind1].subItemList[ind].addonQty = 0;
                    this.clearAddonSelectionSeqForItem(this.foodDetails.addOnInfoList[ind1].subItemList[ind])
				})
				this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose = true;
                this.foodDetails.addOnInfoList[ind1].subItemList[ind2].addonQty = 1;
                this.applyAddonSelectionSeq(group, this.foodDetails.addOnInfoList[ind1].subItemList[ind2], 'select')
                this.normalizeAddonVisibility();
				return
			}				
			// 判断必选 & 单选 判断取消选择：分份池按「池内总和」仍满足 min 才允许取消
			if( this.foodDetails.addOnInfoList[ind1].required == 1 && [0,1].includes(this.foodDetails.addOnInfoList[ind1].selectType) && this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose) {
				const grpReq = this.foodDetails.addOnInfoList[ind1];
				const peerIdxsR = this.getSplitSharedPortionPeerIndicies(grpReq);
				if (peerIdxsR) {
					const minR = this.getEffectiveAddonMinForStep(grpReq);
					const aggR = this.getSplitPoolAggregateStepMetric(grpReq);
					if (aggR - 1 < minR) return;
				} else {
					let judge = false;
					this.foodDetails.addOnInfoList[ind1].subItemList.forEach((ele,ind)=>{
						if(this.foodDetails.addOnInfoList[ind1].subItemList[ind].beingChoose && ind !== ind2) {
							judge = true;
						}
					})
					if(!judge) {
						return
					}
				}
			}
			
			// 判断多选  最多能选几个 customSize  selectType == 3
			let times = 0;
			if(this.foodDetails.addOnInfoList[ind1].selectType == 3 && !this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose) {
				if(this.foodDetails.addOnInfoList[ind1].customSize*1 == 1) {
                    const grpOne = this.foodDetails.addOnInfoList[ind1];
                    if (this.isSplitSharedPoolRow(grpOne)) {
                        const cap1 = this.getSplitPortionSharedPickCap(grpOne);
                        if (cap1 !== Infinity && this.getSplitPoolSelectedOptionCountExcludingGroup(grpOne) + 1 > cap1) {
                            this.notifySplitPoolCapReachedMenuBox();
                            return;
                        }
                    }
					// 自定义多选 只能选1个 但是 是必选处理
					this.foodDetails.addOnInfoList[ind1].subItemList.forEach((ele,ind)=>{
						this.foodDetails.addOnInfoList[ind1].subItemList[ind].beingChoose = false;
                        this.foodDetails.addOnInfoList[ind1].subItemList[ind].addonQty = 0;
                        this.clearAddonSelectionSeqForItem(this.foodDetails.addOnInfoList[ind1].subItemList[ind])
					})
					this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose = !this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose;
                    this.foodDetails.addOnInfoList[ind1].subItemList[ind2].addonQty = this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose ? 1 : 0;
                    this.applyAddonSelectionSeq(group, this.foodDetails.addOnInfoList[ind1].subItemList[ind2], this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose ? 'select' : 'unselect')
                    this.normalizeAddonVisibility();
					return
				}
				
                const grpMulti = this.foodDetails.addOnInfoList[ind1];
                const peerIdxsM = this.getSplitSharedPortionPeerIndicies(grpMulti);
                if (peerIdxsM) {
                    peerIdxsM.forEach(gi => {
                        const gg = this.foodDetails.addOnInfoList[gi];
                        this.getVisibleAddonItems(gg, gi).forEach(sub => {
                            times += this.getAddonPayloadQty(gg, sub);
                        });
                    });
                } else {
                    this.foodDetails.addOnInfoList[ind1].subItemList.forEach((ele,ind)=>{
                        if(this.foodDetails.addOnInfoList[ind1].subItemList[ind].beingChoose) {
                            times += this.getAddonPayloadQty(group, this.foodDetails.addOnInfoList[ind1].subItemList[ind]);
                        }
                    });
                }
                let maxUnits = this.foodDetails.addOnInfoList[ind1].customSize * 1;
                if (peerIdxsM) {
                    const capM = this.getSplitPortionSharedPickCap(grpMulti);
                    if (capM !== Infinity && Number.isFinite(capM)) {
                        maxUnits = Math.min(maxUnits, capM);
                    }
                }
				if(times >= maxUnits) {
                    this.notifySplitPoolCapReachedMenuBox();
					return
				}
			}
			this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose = !this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose;
            this.foodDetails.addOnInfoList[ind1].subItemList[ind2].addonQty = this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose ? 1 : 0;
            this.applyAddonSelectionSeq(group, this.foodDetails.addOnInfoList[ind1].subItemList[ind2], this.foodDetails.addOnInfoList[ind1].subItemList[ind2].beingChoose ? 'select' : 'unselect')
            this.normalizeAddonVisibility();
		},
        getAddonItemQty(item) {
            const n = Number(item && item.addonQty);
            if (Number.isNaN(n) || n < 0) return 0;
            return n;
        },
        getAddonPayloadQty(group, item) {
            if (Number(group && group.allowQty) === 1) {
                const qty = this.getAddonItemQty(item);
                return qty > 0 ? qty : 0;
            }
            return item && item.beingChoose ? 1 : 0;
        },
        notifySplitPoolCapReachedMenuBox() {
            const msg = 'Split portions: limit reached.';
            if (this.$message && this.$message.info) this.$message.info(msg);
        },
        getGroupLimit(group) {
            const tp = Number(group && group.selectType);
            if (tp === 0 || tp === 1) return 1;
            if (tp === 3) {
                const n = Number(group && group.customSize);
                return n > 0 ? n : Infinity;
            }
            return Infinity;
        },
        getSplitPortionSharedPickCap(group) {
            if (!group) return Infinity;
            const tp = Number(group.selectType);
            // selectType 0/1 为单选：分份池「已选选项个数」整池最多 1，勿用 customSize 误放宽
            if (tp === 0 || tp === 1) return 1;
            const cs = Number(group.customSize);
            if (cs > 0) return cs;
            const lim = this.getGroupLimit(group);
            return lim !== Infinity ? lim : Infinity;
        },
        /**
         * 分份 Tab 跨行共用额度：后台开关存 0=关、非 0=开；勿用「===1」否则误存为 2 或与份数混用时整池失效。
         * 仅明确为 0 时关闭；缺省视为开启（兼容旧接口未带字段）。
         */
        isSplitSharedPoolRow(group) {
            if (!group || group.__splitIsPortionRow !== true) return false;
            if (Number(group.allowSplit || 0) !== 1) return false;
            const sc = group.splitConfigCount;
            if (sc === 0 || sc === '0') return false;
            if (sc === undefined || sc === null || sc === '') return true;
            const n = Number(sc);
            if (Number.isNaN(n)) return true;
            return n >= 1;
        },
        getSplitSharedPortionPeerIndicies(seedGroup) {
            if (!seedGroup || !this.isSplitSharedPoolRow(seedGroup)) {
                return null;
            }
            const pool = this.splitAddonUiBundleKey(seedGroup);
            if (!pool) return null;
            const list = (this.foodDetails && this.foodDetails.addOnInfoList) || [];
            const idxs = [];
            list.forEach((g, i) => {
                if (!g) return;
                if (!this.isSplitSharedPoolRow(g)) return;
                if (this.splitAddonUiBundleKey(g) !== pool) return;
                idxs.push(i);
            });
            return idxs.length ? idxs : null;
        },
        getSplitPoolSelectedOptionCountForGroup(gi) {
            const list = (this.foodDetails && this.foodDetails.addOnInfoList) || [];
            const g = list[gi];
            if (!g) return 0;
            let n = 0;
            this.getVisibleAddonItems(g, gi).forEach(sub => {
                if (this.getAddonPayloadQty(g, sub) > 0) n += 1;
            });
            return n;
        },
        getSplitPoolSelectedOptionCountExcludingGroup(seedGroup) {
            const peerIdxs = this.getSplitSharedPortionPeerIndicies(seedGroup);
            if (!peerIdxs) return 0;
            const list = (this.foodDetails && this.foodDetails.addOnInfoList) || [];
            let n = 0;
            peerIdxs.forEach(gi => {
                const g = list[gi];
                if (!g) return;
                if (Number(g.__sourceIndex) === Number(seedGroup.__sourceIndex)) return;
                n += this.getSplitPoolSelectedOptionCountForGroup(gi);
            });
            return n;
        },
        getSplitPoolSelectedOptionCount(seedGroup) {
            const peerIdxs = this.getSplitSharedPortionPeerIndicies(seedGroup);
            if (!peerIdxs) return null;
            let n = 0;
            peerIdxs.forEach(gi => {
                n += this.getSplitPoolSelectedOptionCountForGroup(gi);
            });
            return n;
        },
        getSplitPoolQtySumExcludingCell(seedGroup, excludeSubItemId) {
            const peerIdxs = this.getSplitSharedPortionPeerIndicies(seedGroup);
            if (!peerIdxs) return null;
            const list = (this.foodDetails && this.foodDetails.addOnInfoList) || [];
            const seedSource = seedGroup.__sourceIndex;
            let sum = 0;
            peerIdxs.forEach(gi => {
                const g = list[gi];
                if (!g) return;
                this.getVisibleAddonItems(g, gi).forEach(sub => {
                    const id = String(sub.subItemId || sub.id);
                    const q = this.getAddonPayloadQty(g, sub);
                    if (Number(g.__sourceIndex) === Number(seedSource) && id === String(excludeSubItemId)) return;
                    sum += q;
                });
            });
            return sum;
        },
        changeAddonQty(ind1, ind2, delta, sortedGroupIdx=-1) {
            if(!this.isGroupUnlockedBySortedIndex(sortedGroupIdx)) return;
            const group = this.foodDetails.addOnInfoList[ind1];
            const item = group && group.subItemList ? group.subItemList[ind2] : null;
            if (!group || !item) return;
            this.ensureAddonSplitBranchForGroup(group);
            if (Number(group.allowQty || 0) !== 1) return;

            const nowQty = this.getAddonItemQty(item);
            const desiredQty = Math.max(0, Math.min(99, nowQty + Number(delta || 0)));
            let nextQty = desiredQty;
            const poolCap = this.getSplitPortionSharedPickCap(group);
            const maxChoicesRaw = Number(group.customSize || 0);
            const maxChoices =
                this.isSplitSharedPoolRow(group) &&
                poolCap !== Infinity
                    ? poolCap
                    : maxChoicesRaw;
            if (Number(group.selectType) === 3 && maxChoices > 0) {
                if (this.isSplitSharedPoolRow(group)) {
                    const exId = item.subItemId !== undefined && item.subItemId !== null ? item.subItemId : item.id;
                    const rest = this.getSplitPoolQtySumExcludingCell(group, exId);
                    if (rest !== null && rest + nextQty > maxChoices) {
                        nextQty = Math.max(0, maxChoices - rest);
                    }
                } else {
                    let sumOthers = 0;
                    (group.subItemList || []).forEach(x => {
                        if (x === item) return;
                        sumOthers += this.getAddonPayloadQty(group, x);
                    });
                    if (sumOthers + nextQty > maxChoices) {
                        nextQty = Math.max(0, maxChoices - sumOthers);
                    }
                }
            }
            if (
                Number(delta || 0) > 0 &&
                nextQty < desiredQty &&
                this.isSplitSharedPoolRow(group) &&
                Number(group.selectType) === 3 &&
                maxChoices > 0
            ) {
                this.notifySplitPoolCapReachedMenuBox();
            }
            const selectedCount = (group.subItemList || []).filter(x => this.getAddonItemQty(x) > 0).length;

            if (nextQty === 0 && Number(group.required) === 1 && nowQty > 0) {
                const peerIdxs = this.getSplitSharedPortionPeerIndicies(group);
                const min = this.getEffectiveAddonMinForStep(group);
                if (peerIdxs) {
                    const aggBefore = this.getSplitPoolAggregateStepMetric(group);
                    const aggAfter = aggBefore - (nowQty - nextQty);
                    if (aggAfter < min) return;
                } else if (selectedCount <= 1) {
                    return;
                }
            }

            if (nextQty > 0 && nowQty === 0) {
                if ([0, 1].includes(Number(group.selectType))) {
                    (group.subItemList || []).forEach(x => {
                        x.addonQty = 0;
                        x.beingChoose = false;
                        this.clearAddonSelectionSeqForItem(x)
                    });
                }
            }

            const appliedDelta = nextQty - nowQty
            item.addonQty = nextQty;
            item.beingChoose = nextQty > 0;
            if (appliedDelta !== 0) {
                this.applyAddonSelectionSeq(group, item, 'qty', appliedDelta)
            }
            this.normalizeAddonVisibility();
        },
        // 选择配菜
		chooseIdent(item) {
			if(!this.nowChooseIdent.includes(item.ingredientsId)) {
				this.nowChooseIdent.push(item.ingredientsId);
			} else {
				this.nowChooseIdent.splice(this.nowChooseIdent.indexOf(item.ingredientsId),1)
			}
		},
		// 选择口味 、 烹饪参考 单选
		chooseCookingRef(item) {
			this.nowCookingRef = [item.cookId];
		},
        getFoodTagMode() {
            const tag = String((this.foodDetails && this.foodDetails.foodTag) || (this.nowChooseFood && this.nowChooseFood.foodTag) || '').toLowerCase();
            if (tag === 'pizza' || tag === 'hotpot' || tag === 'burger') return tag;
            if (Number(this.foodDetails && this.foodDetails.addonSort) === 1) return 'sorted';
            return 'default';
        },
        getAddonSortIndex(group, idx) {
            const n = Number(group && group.sortIndex);
            if (!Number.isNaN(n) && n > 0) return n;
            return idx + 1;
        },
        getAddonEffectivePrice(group, item) {
            const base = Number(item && item.addonPrice);
            const basePrice = Number.isNaN(base) ? 0 : base;
            if (Number(group && group.sizePrice) !== 1) return basePrice;
            const sku = (this.foodDetails && this.foodDetails.foodSkuPriceList && this.foodDetails.foodSkuPriceList[this.nowChoose])
                || this.nowPrice
                || (this.nowChooseFood && this.nowChooseFood.foodSkuPriceList && this.nowChooseFood.foodSkuPriceList[this.nowChoose])
                || {};
            const rawSizeId = sku && sku.sizeId;
            const sizeId = rawSizeId && typeof rawSizeId === 'object' ? rawSizeId.sizeId : rawSizeId;
            if (sizeId === undefined || sizeId === null || sizeId === '') return basePrice;
            const groupSizeList = group && Array.isArray(group.foodAddonSizePriceList) ? group.foodAddonSizePriceList : [];
            const topLevelSizeList = this.foodDetails && Array.isArray(this.foodDetails.foodAddonSizePriceList) ? this.foodDetails.foodAddonSizePriceList : [];
            const sizeList = groupSizeList.length ? groupSizeList : topLevelSizeList;
            const addonItemId = item && (item.subItemId || item.id);
            const addonCatId = (group && (group.addonId || group.foodAttrCatId)) || (item && item.addonCatId);
            const matched = sizeList.find(x => {
                if (String(x.addonItemId) !== String(addonItemId)) return false;
                if (String(x.sizeId) !== String(sizeId)) return false;
                if (x.addonCatId === undefined || x.addonCatId === null || x.addonCatId === '') return true;
                return String(x.addonCatId) === String(addonCatId);
            });
            if (!matched || matched.sizePrice === undefined || matched.sizePrice === null || matched.sizePrice === '') {
                return basePrice;
            }
            const p = Number(matched.sizePrice);
            return Number.isNaN(p) ? basePrice : p;
        },
        getAddonDisplayPrice(group, item) {
            return this.getAddonEffectivePrice(group, item).toFixed(2);
        },
        getAddonSummaryLabel(group, item) {
            const qty = this.getAddonPayloadQty(group, item);
            const qtyLabel = Number(group && group.allowQty) === 1 && qty > 1 ? ` x${qty}` : '';
            return `${item.subItemName}${qtyLabel} | ${this.currencySign}${this.getAddonDisplayPrice(group, item)}`;
        },
        getGroupSelectedSummaryItems(group) {
            return (group && group.subItemList ? group.subItemList : []).filter(item => this.getAddonPayloadQty(group, item) > 0);
        },
        /** 与 buildSubItemPayloadRowsForGroup 一致：按用户选择顺序（__selectSeq / __selectSeqs）展开为「每份单价」列表 */
        getAddonUnitPricesInSelectionOrder(group) {
            const units = []
            if (!group || !Array.isArray(group.subItemList)) return units
            ;(group.subItemList || []).forEach(addon => {
                const qty = this.getAddonPayloadQty(group, addon)
                if (!qty || qty <= 0) return
                const unitPrice = this.getAddonEffectivePrice(group, addon)
                if (Number(group.allowQty || 0) === 1 && Array.isArray(addon.__selectSeqs) && addon.__selectSeqs.length) {
                    const seqs = addon.__selectSeqs.slice(0, qty)
                    seqs.forEach(seq => units.push({ seq: Number(seq), price: unitPrice }))
                    for (let i = seqs.length; i < qty; i++) units.push({ seq: 1e15 + i, price: unitPrice })
                } else {
                    const baseSeq = addon.__selectSeq !== undefined && addon.__selectSeq !== null ? Number(addon.__selectSeq) : 1e15
                    for (let i = 0; i < qty; i++) units.push({ seq: baseSeq + i * 1e-6, price: unitPrice })
                }
            })
            units.sort((a, b) => Number(a.seq) - Number(b.seq))
            return units.map(u => u.price)
        },
        getGroupSelectedAddonTotal(group) {
            const selectedPrices = this.getAddonUnitPricesInSelectionOrder(group);
            const freeCount = Number(group && group.freeLimit) === 1 ? Number(group.freeLimitCount || 0) : 0;
            if (freeCount > 0 && selectedPrices.length) {
                // freeLimit：按用户选择顺序优先免费前 N 份（与 subItems / isFree 一致），不看单价高低
                return selectedPrices.slice(freeCount).reduce((sum, n) => sum + n, 0);
            }
            return selectedPrices.reduce((sum, n) => sum + n, 0);
        },
        getGroupMinSelection(group) {
            if (Number(group && group.required) !== 1) return 0;
            if (Number(group && group.selectType) === 3) {
                const n = Number(group && group.customSize);
                return n > 0 ? n : 1;
            }
            return 1;
        },
        /** 分份池 + 有限共享上限：完成度/取消拦截用 min(配置下限, 池上限) */
        getEffectiveAddonMinForStep(group) {
            const raw = this.getGroupMinSelection(group);
            const peerIdxs = this.getSplitSharedPortionPeerIndicies(group);
            if (!peerIdxs) return raw;
            const cap = this.getSplitPortionSharedPickCap(group);
            if (!Number.isFinite(cap) || cap === Infinity) return raw;
            return Math.min(raw, cap);
        },
        getGroupSelectedVisibleCount(group) {
            const visible = this.getVisibleAddonItems(group, group.__sourceIndex);
            if (Number(group && group.selectType) === 3 && Number(group && group.allowQty) === 1) {
                let sum = 0;
                visible.forEach(item => {
                    sum += this.getAddonPayloadQty(group, item);
                });
                const min = this.getGroupMinSelection(group);
                if (min <= 1) return sum;
                return Math.min(sum, min);
            }
            let count = 0;
            visible.forEach(item => {
                // allowQty：以实际数量为准；否则看 beingChoose
                if (Number(group && group.allowQty) === 1) {
                    if (this.getAddonPayloadQty(group, item) > 0) count++;
                } else if (item.beingChoose) {
                    count++;
                }
            });
            const min = this.getGroupMinSelection(group);
            if (min <= 1) return count;
            if (Number(group && group.selectType) === 3) return Math.min(count, min);
            return count;
        },
        /** 分份池内 allowQty 合计（required 按池总和校验） */
        getGroupRawQtySumMenu(group) {
            const visible = this.getVisibleAddonItems(group, group.__sourceIndex);
            let s = 0;
            visible.forEach(item => {
                s += this.getAddonPayloadQty(group, item);
            });
            return s;
        },
        /**
         * 分份 Tab + 共用池开启：同池所有 split 行的选中量合计。
         */
        getSplitPoolAggregateStepMetric(seedGroup) {
            const peerIdxs = this.getSplitSharedPortionPeerIndicies(seedGroup);
            if (!peerIdxs) return null;
            const list = (this.foodDetails && this.foodDetails.addOnInfoList) || [];
            let t = 0;
            peerIdxs.forEach(gi => {
                const g = list[gi];
                if (!g) return;
                if (Number(g.selectType) === 3 && Number(g.allowQty) === 1) {
                    t += this.getGroupRawQtySumMenu(g);
                } else {
                    t += this.getGroupSelectedVisibleCount(g);
                }
            });
            return t;
        },
        isGroupCompleteForStep(group) {
            if (this.getVisibleAddonItems(group, group.__sourceIndex).length === 0) return true;
            const min = this.getEffectiveAddonMinForStep(group);
            if (min <= 0) return true;
            const agg = this.getSplitPoolAggregateStepMetric(group);
            const count = agg !== null ? agg : this.getGroupSelectedVisibleCount(group);
            return count >= min;
        },
        getFirstIncompleteStepGroupIndex() {
            const groups = this.previewAddonGroupsVisible || [];
            for (let i = 0; i < groups.length; i++) {
                if (!this.isGroupCompleteForStep(groups[i])) return i;
            }
            return groups.length - 1;
        },
        addonSortVisibleGroupIndex(group) {
            const vis = this.previewAddonGroupsVisible || [];
            return vis.indexOf(group);
        },
        isGroupInCurrentLogicalStep(group) {
            if (!this.isSortedStepFlow) return true;
            if (this.sortedFlowHasSizeStep && this.currentStepIndex === 0) return false;
            const idx = this.addonSortVisibleGroupIndex(group);
            return idx === this.currentAddonSortedIndex;
        },
        /** addonSort 分步 + allowSplit：标明当前步是整份或哪一条分份 */
        addonSplitStepScopeLabel(group) {
            if (!group || !this.isSortedStepFlow) return '';
            const bt = group.__splitBranchType;
            if (!bt) return '';
            if (bt === 'whole') {
                const t = String((group.__splitPreviewSlotTitle || '') || '').trim();
                return t ? `Entire item: ${t}` : 'Entire item';
            }
            if (bt === 'portion') {
                const t = String((group.__splitPreviewSlotTitle || '') || '').trim();
                if (t) return `Split portions: ${t}`;
                const i = Number(group.__splitPreviewSlotIndex);
                if (Number.isFinite(i) && i >= 0) return `Split portions: #${i + 1}`;
                return 'Split portions';
            }
            return '';
        },
        isGroupUnlockedBySortedIndex(sortedIdx) {
            if (!this.isSortedStepFlow) return true;
            if (this.sortedFlowHasSizeStep && this.currentStepIndex === 0) return false;
            const group = typeof sortedIdx === 'object' ? sortedIdx : (this.previewAddonGroupsVisible || [])[Number(sortedIdx)];
            if (!group) return true;
            return this.addonSortVisibleGroupIndex(group) === this.currentAddonSortedIndex;
        },
        getStepStatusBySortedIndex(sortedIdx) {
            if (!this.isSortedStepFlow) return 'current';
            if (this.sortedFlowHasSizeStep && this.currentStepIndex === 0) return 'locked';
            const group = typeof sortedIdx === 'object' ? sortedIdx : (this.previewAddonGroupsVisible || [])[Number(sortedIdx)];
            if (!group) return 'current';
            const idx = this.addonSortVisibleGroupIndex(group);
            const cur = this.currentAddonSortedIndex;
            if (idx < cur) return 'done';
            if (idx === cur) return 'current';
            return 'locked';
        },
        canGoNextStep() {
            if (!this.isSortedStepFlow) return true;
            if (this.sortedFlowHasSizeStep && this.currentStepIndex === 0) {
                const sid = this.nowPrice && this.nowPrice.sizeId;
                return sid !== '' && sid !== undefined && sid !== null;
            }
            const vis = this.previewAddonGroupsVisible || [];
            const group = vis[this.currentAddonSortedIndex];
            if (!group) return false;
            return this.isGroupCompleteForStep(group);
        },
        getNextStepBlockReason() {
            if (!this.isSortedStepFlow) return '';
            if (this.sortedFlowHasSizeStep && this.currentStepIndex === 0) {
                const sid = this.nowPrice && this.nowPrice.sizeId;
                if (sid === '' || sid === undefined || sid === null) return 'Please choose a size';
                return '';
            }
            const vis = this.previewAddonGroupsVisible || [];
            const group = vis[this.currentAddonSortedIndex];
            if (!group) return 'No step available';
            const min = this.getEffectiveAddonMinForStep(group);
            const name = this.getAddonGroupName(group) || 'Additional items';
            if (min <= 0) return '';
            if ([0, 1].includes(Number(group && group.selectType))) {
                return `Please choose 1 option in "${name}"`;
            }
            if (Number(group && group.selectType) === 3 && Number(group && group.required) === 1 && Number(group && group.customSize) > 1) {
                return `Please choose ${min} options in "${name}"`;
            }
            return `Please make a selection in "${name}"`;
        },
        handleNextStepClick() {
            if (this.canGoNextStep()) {
                this.nextStep();
                return;
            }
            const msg = this.getNextStepBlockReason();
            if (msg) {
                this.$message && this.$message.info ? this.$message.info(msg) : alert(msg);
            }
        },
        nextStep() {
            if (!this.canGoNextStep()) return;
            if (!this.isSortedStepFlow) {
                this.currentStepIndex = Math.min((this.previewAddonGroupsVisible || []).length - 1, this.currentStepIndex + 1);
                return;
            }
            const max = this.sortedFlowTotalSteps - 1;
            this.currentStepIndex = Math.min(max, this.currentStepIndex + 1);
        },
        prevStep() {
            if (!this.isSortedStepFlow) {
                this.currentStepIndex = Math.max(0, this.currentStepIndex - 1);
                return;
            }
            this.currentStepIndex = Math.max(0, this.currentStepIndex - 1);
        },
        hasNextLogicalStep() {
            if (!this.isSortedStepFlow) return false;
            return this.currentStepIndex < this.sortedFlowTotalSteps - 1;
        },
        hasPrevLogicalStep() {
            if (!this.isSortedStepFlow) return false;
            return this.currentStepIndex > 0;
        },
        getSelectedAddonIdSet(maxGroupIdx) {
            const set = new Set();
            (this.foodDetails.addOnInfoList || []).forEach((group, groupIdx) => {
                if (groupIdx > maxGroupIdx) return;
                (group.subItemList || []).forEach(item => {
                    // 选中态统一用 payloadQty（兼容 allowQty=1 / beingChoose 不同步的情况）
                    const q = this.getAddonPayloadQty(group, item);
                    if (q > 0 || item.beingChoose) {
                        const id = item.subItemId || item.id;
                        if (id !== undefined && id !== null && id !== '') set.add(String(id));
                    }
                });
            });
            return set;
        },
        splitAddonGroupKey(group, sortedIdx, prefix) {
            const aid = group && group.addonId != null ? group.addonId : 'addon';
            const src = group && group.__sourceIndex != null ? group.__sourceIndex : sortedIdx;
            const slot =
                group && group.__splitPreviewSlotIndex !== undefined && group.__splitPreviewSlotIndex !== null
                    ? '-' + group.__splitPreviewSlotIndex
                    : '';
            return (prefix ? prefix + '-' : '') + aid + '-' + src + slot + '-' + sortedIdx;
        },
        getAddonSplitDefaultName() {
            return 'Whole';
        },
        normalizeAddonSplitNameList(list, ensureDefault, splitConfigList) {
            const fromApi = Array.isArray(splitConfigList) && splitConfigList.length > 0;
            const raw = fromApi ? splitConfigList : (Array.isArray(list) ? list : []);
            const rows = [];
            raw.forEach((row, idx) => {
                if (!row || typeof row !== 'object') return;
                const dis =
                    row.disabled !== undefined
                        ? !!row.disabled
                        : (Number(row.disable) === 1 || row.disable === true);
                const apiSplit = fromApi && typeof row.split === 'boolean' ? !!row.split : null;
                rows.push({
                    splitName: String((row.splitName != null ? row.splitName : '') || '').trim(),
                    disabled: !!dis,
                    sortIndex:
                        row.sortIndex !== undefined && row.sortIndex !== null && row.sortIndex !== ''
                            ? Number(row.sortIndex)
                            : idx + 1,
                    apiSplit
                });
            });
            rows.sort(function (a, b) {
                const sa = Number(a.sortIndex) || 0;
                const sb = Number(b.sortIndex) || 0;
                return sa - sb;
            });
            const out = rows.map(function (r, i) {
                const splitFlag = r.apiSplit !== null && r.apiSplit !== undefined ? r.apiSplit : (i === 0 ? false : true);
                return {
                    splitName: r.splitName,
                    disabled: r.disabled,
                    sortIndex: i + 1,
                    split: splitFlag
                };
            });
            const hadApiRows = fromApi && out.length > 0;
            if (ensureDefault || out.length) {
                const defaultSplitName = this.getAddonSplitDefaultName();
                if (!out.length) {
                    out.unshift({ splitName: defaultSplitName, disabled: false, sortIndex: 1, split: false });
                }
                if (!hadApiRows) {
                    out[0].splitName = defaultSplitName;
                    out[0].disabled = !!out[0].disabled;
                }
                out.forEach(function (r, i) {
                    r.sortIndex = i + 1;
                    if (!fromApi) {
                        r.split = i === 0 ? false : true;
                    }
                });
            }
            return out;
        },
        cloneAddonSubItemsForSplit(subItemList) {
            return (subItemList || []).map((item, ind) => ({
                ...item,
                __sourceIndex: ind,
                beingChoose: false,
                addonQty: 0
            }));
        },
        expandAddOnGroupForCustomerSplit(group) {
            const g = group || {};
            if (Number(g.allowSplit || 0) !== 1) return [g];
            const slots = this.normalizeAddonSplitNameList(
                g.addonSplitNameList,
                true,
                g.splitConfigList
            );
            const effective = (slots || []).filter(row => row && !row.disabled);
            const wholeSlots = effective.filter(row => row.split === false);
            const portionSlots = effective.filter(row => row.split === true);
            if (!portionSlots.length) return [g];
            const baseTitle = String((g.displayName || g.addonCatName || '')).trim();
            const baseAddonCatId = g.addonId != null ? g.addonId : g.foodAttrCatId;
            const catKey = baseAddonCatId != null ? baseAddonCatId : g.addonCatId != null ? g.addonCatId : 'cat';
            const bundleId = 'split-' + String(catKey) + '-' + String(g.sortIndex != null ? g.sortIndex : 0);
            const portionGroups = portionSlots.map((slot, i) => {
                const portionTitle = String((slot && slot.splitName) || '').trim();
                const title = portionTitle || baseTitle || this.getAddonSplitDefaultName();
                const mergedName = baseTitle ? `${baseTitle} · ${portionTitle || '#' + (i + 1)}` : title;
                const subItemList = this.cloneAddonSubItemsForSplit(g.subItemList);
                return {
                    ...g,
                    subItemList,
                    displayName: mergedName,
                    addonCatName: mergedName,
                    __splitPreviewOnlyShowScope: 'self',
                    __splitPreviewSlotIndex: i,
                    __splitPreviewSlotTitle: portionTitle,
                    __splitPreviewBaseAddonCatId: baseAddonCatId,
                    __splitBundleId: bundleId,
                    __splitPoolKey: bundleId,
                    __splitIsPortionRow: true,
                    __splitBranchType: 'portion'
                };
            });
            if (!wholeSlots.length) {
                return portionGroups.map(function (pg) {
                    const next = { ...pg };
                    delete next.__splitBundleId;
                    delete next.__splitBranchType;
                    next.__splitPoolKey = bundleId;
                    next.__splitIsPortionRow = true;
                    return next;
                });
            }
            const wholeSlot = wholeSlots[0];
            const wholeTitleRaw = String((wholeSlot && wholeSlot.splitName) || '').trim();
            const wholeHeading =
                baseTitle && wholeTitleRaw
                    ? `${baseTitle} · ${wholeTitleRaw}`
                    : baseTitle || wholeTitleRaw || this.getAddonSplitDefaultName();
            const wholeGroup = {
                ...g,
                subItemList: this.cloneAddonSubItemsForSplit(g.subItemList),
                displayName: wholeHeading,
                addonCatName: wholeHeading,
                __splitPreviewOnlyShowScope: 'self',
                __splitPreviewSlotIndex: undefined,
                __splitPreviewSlotTitle: wholeTitleRaw || null,
                __splitPreviewBaseAddonCatId: baseAddonCatId,
                __splitBundleId: bundleId,
                __splitPoolKey: bundleId,
                __splitIsPortionRow: false,
                __splitBranchType: 'whole',
                __splitWholeBranch: true
            };
            return [wholeGroup, ...portionGroups];
        },
        /** 合并重复组：仅在「同 addonCatId + 同子项 + 同名称」且 allowSplit 同时存在 0/1 时合并 */
        mergeSplitAddonCatDuplicates(rawList) {
            const list = [...(rawList || [])];
            const subSig = function (g) {
                return (g && g.subItemList ? g.subItemList : [])
                    .map(function (s) {
                        return String(s.subItemId != null ? s.subItemId : s.id != null ? s.id : '');
                    })
                    .join(',');
            };
            const nameSig = function (g) {
                return String((g && (g.displayName || g.addonCatName)) || '').trim();
            };
            const mergeKey = function (g) {
                if (!g || g.addonCatId === undefined || g.addonCatId === null || g.addonCatId === '') return '';
                // 注意：同 addonCatId 可能本来就有多组（例如 Vegetable Choice / Vegetable Choice 2），不能误合并
                return String(g.addonCatId) + '|' + subSig(g) + '|' + nameSig(g);
            };
            const bucket = {};
            list.forEach(function (g) {
                const k = mergeKey(g);
                if (!k) return;
                if (!bucket[k]) bucket[k] = [];
                bucket[k].push(g);
            });
            const mergedMap = {};
            Object.keys(bucket).forEach(function (k) {
                const arr = bucket[k];
                if (arr.length === 1) {
                    mergedMap[k] = arr[0];
                    return;
                }
                const hasSplit = arr.some(x => Number(x && x.allowSplit) === 1);
                const hasNoSplit = arr.some(x => Number(x && x.allowSplit) !== 1);
                // 只有同时出现 allowSplit 0/1 才认为是“重复配置”需要合并
                if (!(hasSplit && hasNoSplit)) {
                    // 不合并：后续输出时保持原序列（用第一个占位，其他在 list 遍历时会被 seen 拦住，所以这里改策略）
                    // 通过给 mergedMap 标记为 null，表示“不去重”
                    mergedMap[k] = null;
                    return;
                }
                const base = arr.find(x => Number(x && x.allowSplit) === 1) || arr[0];
                const m = { ...base };
                arr.forEach(g => {
                    if (!g) return;
                    if (Number(g.allowSplit || 0) === 1) m.allowSplit = 1;
                    if (Number(g.allowSplit || 0) === 1 && Array.isArray(g.splitConfigList) && g.splitConfigList.length) {
                        m.splitConfigList = [...g.splitConfigList];
                    }
                    if (Number(g.allowSplit || 0) === 1 && g.addonSplitNameList) {
                        m.addonSplitNameList = g.addonSplitNameList;
                    }
                    if (Number(g.allowSplit || 0) === 1 && g.splitConfigCount !== undefined && g.splitConfigCount !== null) {
                        m.splitConfigCount = Number(g.splitConfigCount);
                    }
                });
                mergedMap[k] = m;
            });
            const out = [];
            const seen = new Set();
            list.forEach(function (g) {
                const k = mergeKey(g);
                if (!k) {
                    out.push(g);
                    return;
                }
                const merged = mergedMap[k];
                if (merged === null) {
                    // 不合并：全部保留
                    out.push(g);
                    return;
                }
                if (seen.has(k)) return;
                seen.add(k);
                out.push(merged);
            });
            return out;
        },
        getAddonGroupName(group) {
            if (!group) return '';
            const name = String((group.displayName || group.addonCatName || '')).trim();
            return name;
        },
        /** 整份/分份 Tab 与分支显隐的统一 key（纯分份展开时仅有 __splitPoolKey） */
        splitAddonUiBundleKey(group) {
            if (!group) return '';
            return String(group.__splitBundleId || group.__splitPoolKey || '');
        },
        transformAddOnInfoListForSplit(rawList) {
            const merged = this.mergeSplitAddonCatDuplicates(rawList || []);
            const out = [];
            merged.forEach(group => {
                const parts = this.expandAddOnGroupForCustomerSplit(group);
                parts.forEach(p => out.push(p));
            });
            return out;
        },
        getAddonSplitUiBranch(bundleId) {
            const v = this.addonSplitUiBranch && this.addonSplitUiBranch[bundleId];
            return v === undefined || v === null ? 'whole' : v;
        },
        isAddonSplitBranchVisible(group) {
            if (!group || !group.__splitBranchType) return true;
            const bid = this.splitAddonUiBundleKey(group);
            if (!bid) return true;
            return group.__splitBranchType === this.getAddonSplitUiBranch(bid);
        },
        setAddonSplitBranch(bundleId, mode) {
            if (!bundleId) return;
            const groups = (this.foodDetails && this.foodDetails.addOnInfoList) || [];
            const clearBranch = mode === 'whole' ? 'portion' : 'whole';
            const bid = String(bundleId);
            groups.forEach(g => {
                if (!g || this.splitAddonUiBundleKey(g) !== bid || g.__splitBranchType !== clearBranch) return;
                (g.subItemList || []).forEach(sub => {
                    sub.beingChoose = false;
                    sub.addonQty = 0;
                    this.clearAddonSelectionSeqForItem(sub)
                });
            });
            this.$set(this.addonSplitUiBranch, bundleId, mode);
            this.normalizeAddonVisibility();
            if (this.isSortedStepFlow) {
                const max = Math.max(0, this.sortedFlowTotalSteps - 1);
                if (this.currentStepIndex > max) this.currentStepIndex = max;
            }
        },
        ensureAddonSplitBranchForGroup(group) {
            const bid = this.splitAddonUiBundleKey(group);
            if (!group || !bid || !group.__splitBranchType) return;
            const want = group.__splitBranchType;
            if (this.getAddonSplitUiBranch(bid) === want) return;
            this.setAddonSplitBranch(bid, want);
        },
        buildSubItemPayloadRow(cate, addon) {
            const addonQty = this.getAddonPayloadQty(cate, addon);
            const row = {
                addonQty: addonQty,
                subCatId: addon.addonCatId,
                subItemId: addon.subItemId,
                subItemName: addon.subItemName,
                addonPrice: this.getAddonEffectivePrice(cate, addon)
            };
            const catHeading = String((cate && (cate.displayName || cate.addonCatName)) || '').trim();
            if (catHeading) row.addonCategory = catHeading;
            // 从菜品详情看 sortIndex 在 addon 分组上（cate.sortIndex），需要原封不动回传
            if (cate && cate.sortIndex !== undefined && cate.sortIndex !== null && cate.sortIndex !== '') {
                row.sortIndex = cate.sortIndex;
            }
            if (cate && cate.allowSplit !== undefined && cate.allowSplit !== null && cate.allowSplit !== '') {
                row.allowSplit = cate.allowSplit;
            }
            if (cate && cate.__splitPreviewSlotTitle) {
                row.splitSlotTitle = cate.__splitPreviewSlotTitle;
            }
            if (cate && cate.__splitPreviewSlotIndex !== undefined && cate.__splitPreviewSlotIndex !== null) {
                row.splitSlotIndex = cate.__splitPreviewSlotIndex;
            }
            if (cate && cate.__splitPreviewBaseAddonCatId !== undefined && cate.__splitPreviewBaseAddonCatId !== null && cate.__splitPreviewBaseAddonCatId !== '') {
                row.splitBaseAddonCatId = cate.__splitPreviewBaseAddonCatId;
            }
            if (cate && cate.__splitBranchType) {
                row.splitBranchType = cate.__splitBranchType;
            }
            return row;
        },
        /**
         * 生成加入购物车的 subItems：
         * - 无 freeLimit：每个已选 addon 一条记录，addonQty 为实际数量（避免同一 subItem 复制多行）
         * - 有 freeLimit：仅在需要区分「前 N 份免费 vs 其余付费」时拆行，并按用户选择顺序（seq）决定免费名额
         */
        buildSubItemPayloadRowsForGroup(cate) {
            const out = [];
            if (!cate || !Array.isArray(cate.subItemList)) return out;
            const freeCount = Number(cate && cate.freeLimit) === 1 ? Number(cate.freeLimitCount || 0) : 0;
            if (!freeCount) {
                cate.subItemList.forEach(addon => {
                    const qty = this.getAddonPayloadQty(cate, addon);
                    if (!qty || qty <= 0) return;
                    const row = this.buildSubItemPayloadRow(cate, addon);
                    row.addonQty = qty;
                    out.push(row);
                });
                return out;
            }

            const units = [];
            cate.subItemList.forEach(addon => {
                const qty = this.getAddonPayloadQty(cate, addon);
                if (!qty || qty <= 0) return;
                if (Number(cate && cate.allowQty) === 1 && Array.isArray(addon.__selectSeqs) && addon.__selectSeqs.length) {
                    const seqs = addon.__selectSeqs.slice(0, qty);
                    seqs.forEach(seq => units.push({ addon, seq: Number(seq) }));
                    for (let i = seqs.length; i < qty; i++) units.push({ addon, seq: 1e15 + i });
                } else {
                    const baseSeq = addon.__selectSeq !== undefined && addon.__selectSeq !== null ? Number(addon.__selectSeq) : 1e15;
                    for (let i = 0; i < qty; i++) units.push({ addon, seq: baseSeq + i * 1e-6 });
                }
            });
            units.sort((a, b) => Number(a.seq) - Number(b.seq));

            const sameRowKey = (a, b) =>
                a &&
                b &&
                String(a.subItemId || a.id) === String(b.subItemId || b.id) &&
                Number(a.isFree || 0) === Number(b.isFree || 0);

            const pushOrMergeRow = row => {
                const last = out[out.length - 1];
                if (last && sameRowKey(last, row)) {
                    last.addonQty = Number(last.addonQty || 0) + Number(row.addonQty || 0);
                    return;
                }
                out.push(row);
            };

            units.forEach((u, idx) => {
                const isFreeUnit = idx < freeCount;
                const row = this.buildSubItemPayloadRow(cate, u.addon);
                row.addonQty = 1;
                if (isFreeUnit) row.isFree = 1;
                pushOrMergeRow(row);
            });
            return out;
        },
        isAddonVisible(group, item, groupIdx) {
            const onlyShowId = this.getAddonOnlyShowId(item);
            if (onlyShowId === undefined || onlyShowId === null || onlyShowId === '') return true;
            let selectedIds;
            if (group && group.__splitPreviewOnlyShowScope === 'self') {
                selectedIds = new Set();
                (group.subItemList || []).forEach(sub => {
                    const q = this.getAddonPayloadQty(group, sub);
                    if (q > 0 || sub.beingChoose) {
                        const id = sub.subItemId || sub.id;
                        if (id !== undefined && id !== null && id !== '') selectedIds.add(String(id));
                    }
                });
            } else {
                selectedIds = this.getSelectedAddonIdSet(groupIdx);
            }
            return selectedIds.has(String(onlyShowId));
        },
        getAddonOnlyShowId(item) {
            if (!item) return '';
            const direct = item.onlyShowAddonItemId;
            if (direct !== undefined && direct !== null && direct !== '') return direct;
            const nested = item.item && typeof item.item === 'object' ? item.item.onlyShowAddonItemId : '';
            return nested !== undefined && nested !== null ? nested : '';
        },
        applyLegacyAddonOnlyShowListToItems(obj) {
            if (!obj) return;
            const globalRows = Array.isArray(obj.foodAddonOnlyShowList) ? obj.foodAddonOnlyShowList : [];
            const globalDict = {};
            globalRows.forEach(r => {
                if (!r) return;
                const k = r.addonItemId !== undefined && r.addonItemId !== null ? String(r.addonItemId) : '';
                if (!k) return;
                globalDict[k] = r.onlyShowAddonItemId;
            });
            (obj.addOnInfoList || []).forEach(group => {
                const dict = { ...globalDict };
                const rows = Array.isArray(group && group.foodAddonOnlyShowList) ? group.foodAddonOnlyShowList : [];
                rows.forEach(r => {
                    if (!r) return;
                    const k = r.addonItemId !== undefined && r.addonItemId !== null ? String(r.addonItemId) : '';
                    if (!k) return;
                    dict[k] = r.onlyShowAddonItemId;
                });
                (group.subItemList || []).forEach(it => {
                    if (!it) return;
                    const id = it.subItemId !== undefined && it.subItemId !== null ? String(it.subItemId) : (it.id !== undefined && it.id !== null ? String(it.id) : '');
                    if (!id) return;
                    if ((it.onlyShowAddonItemId === undefined || it.onlyShowAddonItemId === null || it.onlyShowAddonItemId === '') && dict[id] !== undefined) {
                        it.onlyShowAddonItemId = dict[id];
                    }
                    if (it.item && typeof it.item === 'object' && (it.item.onlyShowAddonItemId === undefined || it.item.onlyShowAddonItemId === null || it.item.onlyShowAddonItemId === '') && dict[id] !== undefined) {
                        it.item.onlyShowAddonItemId = dict[id];
                    }
                });
                if (group && group.foodAddonOnlyShowList) delete group.foodAddonOnlyShowList;
            });
            if (obj.foodAddonOnlyShowList) delete obj.foodAddonOnlyShowList;
        },
        getVisibleAddonItems(group, groupIdx) {
            return (group && group.subItemList ? group.subItemList : []).filter(item => this.isAddonVisible(group, item, groupIdx));
        },
        normalizeAddonVisibility() {
            (this.foodDetails.addOnInfoList || []).forEach((group, groupIdx) => {
                const visible = this.getVisibleAddonItems(group, groupIdx);
                const visibleSet = new Set(visible.map(x => String(x.subItemId || x.id)));
                (group.subItemList || []).forEach(item => {
                    const id = String(item.subItemId || item.id);
                    if (!visibleSet.has(id)) {
                        item.beingChoose = false;
                        item.addonQty = 0;
                        this.clearAddonSelectionSeqForItem(item)
                    }
                });
                if (Number(this.foodDetails && this.foodDetails.addonSort) !== 1 && Number(group.required) === 1) {
                    const selected = (group.subItemList || []).filter(item => item.beingChoose && visibleSet.has(String(item.subItemId || item.id)));
                    if (!selected.length && visible.length) {
                        visible[0].beingChoose = true;
                        visible[0].addonQty = this.getAddonItemQty(visible[0]) > 0 ? this.getAddonItemQty(visible[0]) : 1;
                        this.applyAddonSelectionSeq(group, visible[0], 'select')
                    }
                }
            });
            if (this.isSortedStepFlow) {
                const max = Math.max(0, this.sortedFlowTotalSteps - 1);
                if (max < 0) {
                    this.currentStepIndex = 0;
                } else if (this.currentStepIndex > max) {
                    this.currentStepIndex = max;
                }
            }
        },
        getFoodDetails(item) { // 获取食品详情
            this.nowChooseIdent = [];
			this.nowCookingRef = [];
            this.currentStepIndex = 0;
            this.addonSplitUiBranch = {};
            this.loadingFood = true;
            postGateway({
                url: '/customerApp/merchantDetail/getFoodDetail',
                method: 'GET',
                data: {
                    itemId: this.nowChooseFood.itemId
                }
            }).then(res=>{
                let obj = res.data;
				obj.cookingRefList = res.data.cookingRefList?res.data.cookingRefList:[];
				if(obj.cookingRefList.length > 0) {
					this.nowCookingRef = [obj.cookingRefList[0].cookId];
				}
				obj.catId = item.catId;
                const rawAddonList = Array.isArray(obj.addOnInfoList) ? [...obj.addOnInfoList] : [];
                obj.addOnInfoList = this.transformAddOnInfoListForSplit(rawAddonList);
                // 兼容旧结构：foodAddonOnlyShowList -> subItemList item.onlyShowAddonItemId
                this.applyLegacyAddonOnlyShowListToItems(obj);
				obj.addOnInfoList.forEach((cate, catInd) => {
                    obj.addOnInfoList[catInd].__sourceIndex = catInd;
					(cate.subItemList || []).forEach((sub, ind) => {
                        obj.addOnInfoList[catInd].subItemList[ind].__sourceIndex = ind;
						if (ind === 0 && cate.required == 1 && Number(obj.addonSort || 0) !== 1) {
							obj.addOnInfoList[catInd].subItemList[ind].beingChoose = true;
                            obj.addOnInfoList[catInd].subItemList[ind].addonQty = 1;
						} else {
							obj.addOnInfoList[catInd].subItemList[ind].beingChoose = false;
                            obj.addOnInfoList[catInd].subItemList[ind].addonQty = 0;
						}
					});
				});
				this.foodDetails = obj;
                this.normalizeAddonVisibility();
                this.loadingFood = false;
                this.nowChoose = 0;
                this.measureFloatingSelectionSummary();
            }).catch(()=>{
                this.loadingFood = false;
                this.measureFloatingSelectionSummary();
            })
        },
        // 选择规格 同步个数
		chooseSkuPrice(item,index) {
			this.nowChoose = index;
            console.log(item, index)
		},
        nowChoosePrice(item, ind) {
            this.nowPrice = item;
            this.nowChoose = ind;
        },
        addCart(food, isAdd=false) {
            console.log(food,'当前food')
            // 多价格不能直接加入购物车
            if((food.foodSkuPriceList && food.foodSkuPriceList.length>1) || food.isAddon) {
                this.nowChooseFood = food;
                this.nowPrice = food.foodSkuPriceList[0]
                this.showModal = true;

                let keyArr = ['addOnInfoList', 'ingredientsList', 'cookingRefList'];
                keyArr.forEach(ele=>{
                    this.foodDetails[ele] = []
                })

                if(food.isAddon) {
                    this.getFoodDetails(food)
                } else {
                    this.loadingFood = false;
                    this.foodDetails = {
                        addOnInfoList: [],
                        ingredientsList: [],
                        cookingRefList: [],
                        ...food
                    };
                    console.log('执行了这里去掉loading')
                }
                return
            }
            let item = food;

            // 判断购价格是否过多了
			// if((item.foodSkuPriceList[0].foodPrice *1 + this.nowTotalPrice*1) > this.MaxShopPrice) {
			// 	this.$message.info('Over max shop price')
			// 	return
			// }

            isAdd ? item.qty++ : item.qty--;
            // 一口价的菜品直接加入购物车
			let param = {
				clientId: this.clientId,
				categoryId: item.catId,
				qty: item.qty,  // 新增传1
				price: item.foodSkuPriceList[0].foodPrice,
				itemId: item.itemId,
                itemName: item.itemName,
				merchantId: this.info.merchantId,
				foodSkuId: item.foodSkuPriceList[0].foodSkuId,
				cookingRef: [],	// 待定
				ingredients: [],// 待定
				subItems: [],// 待定
			}

            if(param.qty > 0) {
                this.checkToCart(param).then((res)=>{
                    this.applyServerTotalPriceToParam(param, res);
                    this.$emit('addCart', param, 'single')
                    this.addCartLoading = null;
                })
                .catch((err)=>{
                    console.log(err,'err')
                    if(err.code !== 50032) {
                        this.$message.error(err.msg)
                    }
                    this.addCartLoading = null;
                    // 加入失败 复原数量
                    isAdd ? item.qty-- : item.qty++;
                })
            } else {
                this.$emit('addCart', param, 'single')
            }
        },
        handleClose() {
            this.showModal = false;
            this.freeItemModal = false;
            this.nowChooseIdent = [];
            this.nowCookingRef = [];
            this.currentStepIndex = 0;
            this.addonSplitUiBranch = {};
            this.foodDetails.addOnInfoList = []
            this.foodDetails.ingredientsList = []
            this.foodDetails.cookingRefList = []
            this.floatingSelectionSummaryExpanded = false;
            this.floatingSelectionSummaryExpandable = false;
            this.floatingSelectionMeasuring = false;
        },
        // 外部在跳转前主动关闭 FreeItem 弹窗
        closeFreeItemModal() {
            this.freeItemModal = false;
        },
    }
}
</script>
<style lang="scss" scoped>
.menu-content {
    padding: 10px 20px 20px;
    min-height: 100vh;

    .distance-box {
        height: 40px;
        display: flex;
        align-items: flex-end;
        font-size: 15px;
        font-weight: 600;
        padding: 0 10px;

        i {
            font-size: 24px;
            margin-right: 5px;
            font-weight: bold;
            color: #000 !important;
        }
    }

    .menu-title {
        position: sticky;
        padding-top: 10px;
        background-color: #fff;
        top: 0px;

        h2 {
            font-weight: 700;
            color: #fff;
            font-size: 25px;
            padding: 10px 20px 10px;
            margin: 0;
            background-color: #09CA6A;
            border-radius: 6px;
            box-shadow: 0px 4px 6px #8F9698;
        }
    }

    .modal-title {
        text-align: center;
        font-weight: 600;
        color: #222;
        font-size: 18px;
        white-space: pre-wrap;
    }
    @media (min-width: 480px) {
        :deep(.food-detail-dialog) {
            min-width: 424px;
        }
    }
    /* 移动版：菜品详情 / FreeItem 底部按钮更紧凑；主弹窗不展示 Cancel（可点遮罩或右上角关闭） */
    @media (max-width: 949px) {
        :deep(.food-detail-dialog) {
            .el-dialog__footer {
                padding: 8px 12px 12px;
            }
            .modal-footer {
                flex-wrap: wrap;
                gap: 8px;
                row-gap: 8px;
            }
            .modal-footer .el-button {
                padding-left: 12px;
                padding-right: 12px;
                font-size: 13px;
                min-height: 34px;
            }
            .modal-footer .el-button + .el-button {
                margin-left: 0;
            }
            .modal-footer-total {
                flex: 1 1 100%;
                margin-right: 0;
                margin-bottom: 2px;
                justify-content: space-between;
            }
        }
    }
    :deep(.el-dialog__body) {
        padding-right: 0;
        padding-bottom: 0;
        overflow-x: hidden;
    }
    .modal-content {
        margin-top: -20px;
        max-height: 60vh;
        overflow-x: hidden;
        overflow-y: auto;
        padding-right: 16px;
        margin-right: 4px;
        min-width: 0;

        &::-webkit-scrollbar {
            width: 6px;
        }

        .price-title {
            color: #09CA6A;
            font-size: 16px;
            text-align: left;
            margin-bottom: 15px;
        }
        .dash-row {
            margin: 15px 0;
            border-top: 1px dashed #cacaca
        }
        .addon-title {
            color: #aa0bc0;
            margin-bottom: 15px;
            margin-top: 10px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 6px;
        }
        .addon-split-step-scope {
            font-size: 12px;
            font-weight: 600;
            color: #5b21b6;
            margin: -8px 0 10px;
            line-height: 1.35;
        }
        .addon-meta-tag {
            display: inline-flex;
            align-items: center;
            border-radius: 999px;
            background: #f1f5f9;
            color: #475569;
            font-size: 11px;
            padding: 1px 8px;
        }
        .addon-step-state {
            display: inline-flex;
            align-items: center;
            border-radius: 999px;
            font-size: 11px;
            padding: 1px 8px;
            font-weight: 700;
        }
        .addon-step-state.is-done {
            background: #dcfce7;
            color: #166534;
        }
        .addon-step-state.is-current {
            background: #ede9fe;
            color: #5b21b6;
        }
        .addon-step-state.is-locked {
            background: #f3f4f6;
            color: #6b7280;
        }
        .price-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 15px;
            padding: 6px 10px;
            border-radius: 0;
            border: 1px solid #e5e7eb;
            margin-bottom: 10px;
            color: #000;
            cursor: pointer;
            .old-price {
                text-decoration: line-through;
                color: #9d9e9e;
                padding-right: 2px;
                font-size: 12px;
            }
        }
        .price-item-active {
            color: #aa0bc0;
            border: 1px solid #aa0bc0;
            background-color: #f9eafc;
        }
        /* 规格行在 ul 内，提高优先级避免被其它规则盖成灰底 */
        ul .price-item.price-item-active {
            color: #aa0bc0;
            border: 1px solid #aa0bc0;
            background-color: #f9eafc;
        }
        .addon-sort-progress-track {
            height: 4px;
            background: #e5e7eb;
            border-radius: 2px;
            margin: 4px 0 12px;
            overflow: hidden;
        }
        .addon-sort-progress-fill {
            height: 100%;
            background: #14532d;
            border-radius: inherit;
            transition: width 0.2s ease;
        }
        .addon-split-mode-tabs {
            display: flex;
            gap: 0;
            margin-bottom: 10px;
            border-bottom: 1px solid #e5e7eb;
        }
        .addon-split-mode-btn {
            flex: 1;
            padding: 8px 10px 10px;
            border-radius: 0;
            border: none;
            border-bottom: 3px solid transparent;
            margin-bottom: -1px;
            background: transparent;
            font-size: 13px;
            font-weight: 600;
            color: #86a593;
            cursor: pointer;
        }
        .addon-split-mode-btn:hover {
            color: #6d9a7e;
            background: #f0fdf4;
        }
        .addon-split-mode-btn.is-active {
            border-bottom-color: #86efac;
            color: #3f7d55;
            background: #ecfdf5;
        }
        .addon-split-mode-tabs--step-header {
            margin-top: 2px;
        }
        .modal-floating-selection {
            position: sticky;
            bottom: 0;
            z-index: 8;
            margin: 12px 0 4px;
            padding: 10px 12px;
            background: rgba(255, 255, 255, 0.97);
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            box-shadow: 0 -6px 16px rgba(0, 0, 0, 0.06);
            overflow-x: hidden;
            max-width: 100%;
        }
        /** 底部已选：浅底 + 顶阴影，与上方滚动区整块区分（不加复杂条带） */
        .modal-floating-selection--selection-summary {
            margin-top: 8px;
            padding-top: 12px;
            padding-bottom: 12px;
            background: #f3f4f6;
            border: none;
            border-top: 1px solid #e5e7eb;
            border-radius: 0;
            box-shadow: 0 -10px 28px rgba(15, 23, 42, 0.08);
            overflow-x: hidden;
        }
        .modal-floating-selection__row {
            font-size: 12px;
            font-weight: 600;
            color: #111827;
            line-height: 1.45;
            word-break: break-word;
        }
        .modal-floating-selection__row--muted {
            font-weight: 500;
            color: #374151;
            margin-top: 4px;
            font-size: 11px;
        }
        .modal-floating-selection__lines-wrap {
            line-height: 1.55;
            word-break: break-word;
            overflow-x: hidden;
            max-width: 100%;
        }
        .modal-floating-selection__lines-wrap.is-collapsed {
            max-height: 80px;
            overflow: hidden;
        }
        .modal-floating-selection__line {
            margin-top: 8px;
            font-size: 12px;
            font-weight: 500;
            color: #334155;
            line-height: 1.5;
        }
        .modal-floating-selection__line:first-child {
            margin-top: 0;
        }
        .modal-floating-selection__line-title {
            font-weight: 600;
            font-size: 12px;
            color: #64748b;
        }
        .modal-floating-selection__line-value {
            font-weight: 500;
            color: #0f172a;
        }
        .modal-floating-selection__toggle {
            display: block;
            width: 100%;
            margin-top: 8px;
            padding: 4px 0 0;
            border: none;
            background: transparent;
            cursor: pointer;
            font-size: 12px;
            font-weight: 600;
            color: #475569;
            text-align: center;
        }
        .modal-floating-selection__toggle:hover {
            color: #0f172a;
            text-decoration: underline;
        }
        .addon-box {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .price-item-addon {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                gap: 12px;
                font-size: 14px;
                padding: 10px 12px;
                border-radius: 0;
                border: 1px solid #e5e7eb;
                margin-bottom: 0;
                margin-right: 0;
                width: 100%;
                box-sizing: border-box;
                color: #000;
                cursor: pointer;
                background: #fff;
            }
            .price-item-addon--row .addon-row-left {
                display: inline-flex;
                align-items: center;
                gap: 10px;
                min-width: 0;
                flex: 1;
            }
            .addon-row-name {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .addon-row-indicator {
                width: 18px;
                height: 18px;
                border-radius: 50%;
                border: 2px solid #d1d5db;
                flex-shrink: 0;
                box-sizing: border-box;
            }
            .addon-row-indicator.is-on {
                border-color: #aa0bc0;
                box-shadow: inset 0 0 0 4px #c471ed;
            }
            .addon-row-price {
                flex-shrink: 0;
                font-weight: 600;
                color: #374151;
            }
            .addon-qty-wrap {
                display: inline-flex;
                align-items: center;
                gap: 6px;
                margin-left: 0;
                flex-shrink: 0;
            }
            .addon-qty-btn {
                width: 20px;
                height: 20px;
                border: 1px solid #d1d5db;
                border-radius: 6px;
                background: #fff;
                color: #374151;
                line-height: 18px;
                font-size: 14px;
                cursor: pointer;
                padding: 0;
            }
            .addon-qty-btn:hover {
                background: #f3f4f6;
            }
            .addon-qty-num {
                min-width: 18px;
                text-align: center;
                font-weight: 600;
                color: #111827;
            }
            .price-item-active {
                color: #aa0bc0;
                border: 1px solid #aa0bc0;
                background-color: #f9eafc;
            }
            .price-item-active .addon-row-price {
                color: #aa0bc0;
            }
            .price-item-locked {
                opacity: 1;
                cursor: not-allowed;
                pointer-events: none;
                color: #9ca3af;
                background-color: #f3f4f6;
                border-color: #e5e7eb;
            }
            .price-item-locked .addon-row-price {
                color: #9ca3af;
            }
        }
        .step-summary-box {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin-bottom: 10px;
        }
        .step-summary-tag {
            display: inline-flex;
            align-items: center;
            border-radius: 10px;
            border: 1px solid #e5e7eb;
            background: #f8fafc;
            color: #334155;
            font-size: 12px;
            padding: 4px 8px;
        }
        .step-summary-empty {
            color: #9ca3af;
            font-size: 12px;
        }
        &.foodtag-mode-pizza {
            .addon-title {
                color: #b45309;
            }
            ul .price-item.price-item-active {
                color: #aa0bc0;
                border-color: #aa0bc0;
                background-color: #f9eafc;
            }
            .price-item-addon {
                // border-color: #fed7aa;
                background: transparent;
            }
            .addon-box .price-item-addon.price-item-active {
                color: #aa0bc0;
                border-color: #aa0bc0;
                background-color: #f9eafc;
            }
            .addon-box .price-item-addon.price-item-locked {
                background-color: #f3f4f6;
            }
        }
        &.foodtag-mode-hotpot {
            .addon-title {
                color: #1d4ed8;
            }
            ul .price-item.price-item-active {
                color: #aa0bc0;
                border-color: #aa0bc0;
                background-color: #f9eafc;
            }
            .price-item-addon {
                border-color: #bfdbfe;
                background: #eff6ff;
            }
            .addon-box .price-item-addon.price-item-active {
                color: #aa0bc0;
                border-color: #aa0bc0;
                background-color: #f9eafc;
            }
            .addon-box .price-item-addon.price-item-locked {
                background-color: #f3f4f6;
                border-color: #e5e7eb;
            }
        }
        &.foodtag-mode-burger {
            .addon-title {
                color: #166534;
            }
            ul .price-item.price-item-active {
                color: #aa0bc0;
                border-color: #aa0bc0;
                background-color: #f9eafc;
            }
            .price-item-addon {
                border-color: #bbf7d0;
                background: #f0fdf4;
            }
            .addon-box .price-item-addon.price-item-active {
                color: #aa0bc0;
                border-color: #aa0bc0;
                background-color: #f9eafc;
            }
            .addon-box .price-item-addon.price-item-locked {
                background-color: #f3f4f6;
                border-color: #e5e7eb;
            }
        }
        &.foodtag-mode-sorted {
            ul .price-item.price-item-active {
                color: #aa0bc0;
                border-color: #aa0bc0;
                background-color: #f9eafc;
            }
            .addon-meta-tag {
                background: #ede9fe;
                color: #5b21b6;
            }
        }
    }
    .modal-footer--free-step {
        width: 100%;
        justify-content: flex-start;
    }
    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
    }
    .modal-footer-total {
        margin-right: auto;
        display: inline-flex;
        align-items: baseline;
        gap: 8px;
        font-size: 13px;
        color: #111827;
    }
    .modal-footer-total strong {
        font-size: 15px;
        font-weight: 700;
        color: #111827;
    }

    .modal-img {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 15px;
		margin-top: -30px;
		.alleat-icon {
			height: 55px;
			width: 55px;
		}
	}
	.modal-desc {
		font-weight: normal;
		font-size: 15px;
		margin-top: 10px;
		color: #000;
		text-align: center;
	}
	.modal-desc-bold {
		font-weight: bolder;
		font-size: 14px;
	}
	.modal-desc-name {
		font-weight: bold;
		font-size: 19px;
		margin-top: 18px;
		margin-bottom: 18px;
	}
	.modal-desc-name-normal {
		font-weight: bold;
		font-size: 15px;
	}
	.free-item-btn {
		height: 40px;
		width: 100%;
		border-radius: 20px;
		margin-top: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		background-color: #ab1ec4;
		color: #fff;
	}
	
	.modal-food-img {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 12px;
		img {
			height: 110px;
			width: 110px;
		}
	}

    .free-item-modal {
        .modal-content {
            padding-right: 0;
            max-height: 34vh;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }

    .search-box {
        background-color: #fff;
        margin-top: 20px;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    }
    .cate-box {
        padding: 10px 20px 20px;
        border-radius: 8px;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
        margin-top: 20px;
        background-color: #fff;

        h2 {
            font-weight: bold;
            font-size: 24px;
            color: #000;
            margin: 0;
            white-space: pre-wrap;
            word-wrap: break-word;
        }

        .desc {
            font-size: 15px;
            color: #0A191E;
            padding: 10px 0 10px;
            word-break: normal;
            white-space: pre-wrap;
        }
    }
    .loading-box , .food-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px 0 20px 0;
        .el-icon-loading {
            color: #AA0BC0;
            font-size: 25px;
        }
        .empty-img {
            width: 400px;
            border-radius: 12px;
        }
    }
    .food-item {
        background-color: #fff;
        display: flex;
        border-bottom: 0.5px solid #00000033;
        padding: 15px 0;
        align-items: center;
        font-family: "Source Sans Pro", sans-serif;

        &:hover {
            background-color: #f7f5f5;
        }

        .item-name {
            flex: 1;
            display: flex;
            word-break: normal;
            padding-left: 10px;
            overflow: hidden;
            white-space: normal;
            font-size: 12px;

            .food-img {
                height: 60px;
                width: 60px;
                min-width: 60px;
                border-radius: 6px;
                background-color: #e9e9e9;
                overflow: hidden;
                margin-right: 10px;
                object-fit: contain;
            }

            img {
                height: 60px;
                width: 60px;
            }

            .name {
                font-size: 15px;
                color: #333;
                font-weight: bold;
            }

            .name-desc {
                margin: 0 4px;
                font-size: 20px;
            }

            .desc {
                font-size: 14px;
                color: #8d8d8d;
                font-weight: 400;
            }
            .price {
                font-weight: bold;
                color: #000;
                margin-top: 8px;
                font-size: 19px;
                .origin-price {
                    text-decoration: line-through;
                    color: #999;
                    font-weight: 500;
                    font-size: 15px;
                }
            }
        }

        .item-price {
            padding-left: 10px;
            min-width: 60px;
            width: 20%;
            text-align: left;
            font-weight: 600;
        }

        .item-order {
            width: 20%;
            min-width: 100px;
            text-align: center;

            .add-btn {
                min-width: 90px;
                height: 32px;
                border: 2px solid #AA0BC0;
                border-radius: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                color: #AA0BC0;
                font-weight: 700;
                padding: 0 14px;
                cursor: pointer;
                transition: all ease-in .2s;
                white-space: nowrap;

                i {
                    color: #AA0BC0;
                    margin-right: 2px;
                    font-weight: 700;
                    font-size: 12px;
                    margin-right: 4px;
                }

                .qty {
                    color: #000;
                }

                &:hover {
                    background-color: #AA0BC0;
                    border: 2px solid #fff;
                    color: #fff;

                    i {
                        color: #fff;
                    }
                }
            }
            .add-addon {
                background-color: #AA0BC0;
                color: #fff;
                font-weight: 500;
            }

            .el-icon-delete {
                margin-left: 2px;
            }
            .update-btn {
                display: flex;
                justify-content: space-between;
                border: 1px solid rgba(0, 0, 0, 0.25);
                i {
                    margin: 0;
                }
            }

        }
    }

    .food-header {
        font-weight: bold;
        color: #000;
        border-top: 0.5px solid #00000033;
        padding: 20px 0;
        background-color: #f7f5f5;

        .item-price {
            padding-left: 0;
            text-align: left;
            font-weight: 600;
            padding-left: 10px;
        }

        .item-order {
            padding-right: 20px;
        }
    }
}

@media screen and (max-width: 950px) {
    .menu-box .menu-content{
        padding: 10px 10px 20px;
        font-family: "Source Sans Pro", sans-serif;
        .distance-box {
            height: auto;
        }
        .menu-title h2{
            font-size: 18px;
        }
        .cate-box {
            background-color: #fff!important;
            h2 {
                font-size: 15px;
            }
            .food-box {
                .food-item {
                    font-family: "Source Sans Pro", sans-serif;
                    .index-num {
                        font-size: 12px;
                        color: #09a054;
                        font-weight: bold;
                        margin-right: 10px;
                    };
                    .item-name {
                        .name {
                            font-size: 15px;
                        }
                        .desc {
                            font-size: 12px;
                        }
                    }
                    .add-btn {
                        font-size: 13px;
                    }
                }
            }
        }
        .modal-title {
            word-break: normal;
            overflow: hidden;
            font-size: 14px;
            font-weight: bold;
        }
        .modal-content {
            .price-title {
                font-weight: bold;
                font-size: 14px;
            }
            ul .price-item {
                font-size: 12px;
            }
            .addon-title {
                font-size: 13px;
            }
            .addon-box {
               .price-item-addon {
                font-size: 12px;
               }
            }
        }
    }
}

</style>